const so = /* @__PURE__ */ new Map(), Je = () => so;
/*! js-cookie v3.0.5 | MIT */
function F0(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r];
    for (var a in t)
      e[a] = t[a];
  }
  return e;
}
var fo = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function _r(e, r) {
  function t(n, o, u) {
    if (!(typeof document > "u")) {
      u = F0({}, r, u), typeof u.expires == "number" && (u.expires = new Date(Date.now() + u.expires * 864e5)), u.expires && (u.expires = u.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var h in u)
        u[h] && (f += "; " + h, u[h] !== !0 && (f += "=" + u[h].split(";")[0]));
      return document.cookie = n + "=" + e.write(o, n) + f;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], u = {}, f = 0; f < o.length; f++) {
        var h = o[f].split("="), i = h.slice(1).join("=");
        try {
          var s = decodeURIComponent(h[0]);
          if (u[s] = e.read(i, s), n === s)
            break;
        } catch {
        }
      }
      return n ? u[n] : u;
    }
  }
  return Object.create(
    {
      set: t,
      get: a,
      remove: function(n, o) {
        t(
          n,
          "",
          F0({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return _r(this.converter, F0({}, this.attributes, n));
      },
      withConverter: function(n) {
        return _r(F0({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(r) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var We = _r(fo, { path: "/" }), I = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ue(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function co(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function a() {
      return this instanceof a ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var n = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(t, a, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), t;
}
var Mn = { exports: {} };
function lo(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ot = { exports: {} };
const uo = {}, xo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uo
}, Symbol.toStringTag, { value: "Module" })), ho = /* @__PURE__ */ co(xo);
var Qr;
function P() {
  return Qr || (Qr = 1, function(e, r) {
    (function(t, a) {
      e.exports = a();
    })(I, function() {
      var t = t || function(a, n) {
        var o;
        if (typeof window < "u" && window.crypto && (o = window.crypto), typeof self < "u" && self.crypto && (o = self.crypto), typeof globalThis < "u" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window < "u" && window.msCrypto && (o = window.msCrypto), !o && typeof I < "u" && I.crypto && (o = I.crypto), !o && typeof lo == "function")
          try {
            o = ho;
          } catch {
          }
        var u = function() {
          if (o) {
            if (typeof o.getRandomValues == "function")
              try {
                return o.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof o.randomBytes == "function")
              try {
                return o.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, f = Object.create || function() {
          function v() {
          }
          return function(p) {
            var x;
            return v.prototype = p, x = new v(), v.prototype = null, x;
          };
        }(), h = {}, i = h.lib = {}, s = i.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(v) {
              var p = f(this);
              return v && p.mixIn(v), (!p.hasOwnProperty("init") || this.init === p.init) && (p.init = function() {
                p.$super.init.apply(this, arguments);
              }), p.init.prototype = p, p.$super = this, p;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var v = this.extend();
              return v.init.apply(v, arguments), v;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(v) {
              for (var p in v)
                v.hasOwnProperty(p) && (this[p] = v[p]);
              v.hasOwnProperty("toString") && (this.toString = v.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), b = i.WordArray = s.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(v, p) {
            v = this.words = v || [], p != n ? this.sigBytes = p : this.sigBytes = v.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(v) {
            return (v || c).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(v) {
            var p = this.words, x = v.words, S = this.sigBytes, E = v.sigBytes;
            if (this.clamp(), S % 4)
              for (var k = 0; k < E; k++) {
                var C = x[k >>> 2] >>> 24 - k % 4 * 8 & 255;
                p[S + k >>> 2] |= C << 24 - (S + k) % 4 * 8;
              }
            else
              for (var A = 0; A < E; A += 4)
                p[S + A >>> 2] = x[A >>> 2];
            return this.sigBytes += E, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var v = this.words, p = this.sigBytes;
            v[p >>> 2] &= 4294967295 << 32 - p % 4 * 8, v.length = a.ceil(p / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var v = s.clone.call(this);
            return v.words = this.words.slice(0), v;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(v) {
            for (var p = [], x = 0; x < v; x += 4)
              p.push(u());
            return new b.init(p, v);
          }
        }), l = h.enc = {}, c = l.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(v) {
            for (var p = v.words, x = v.sigBytes, S = [], E = 0; E < x; E++) {
              var k = p[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              S.push((k >>> 4).toString(16)), S.push((k & 15).toString(16));
            }
            return S.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(v) {
            for (var p = v.length, x = [], S = 0; S < p; S += 2)
              x[S >>> 3] |= parseInt(v.substr(S, 2), 16) << 24 - S % 8 * 4;
            return new b.init(x, p / 2);
          }
        }, d = l.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(v) {
            for (var p = v.words, x = v.sigBytes, S = [], E = 0; E < x; E++) {
              var k = p[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              S.push(String.fromCharCode(k));
            }
            return S.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(v) {
            for (var p = v.length, x = [], S = 0; S < p; S++)
              x[S >>> 2] |= (v.charCodeAt(S) & 255) << 24 - S % 4 * 8;
            return new b.init(x, p);
          }
        }, _ = l.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(v) {
            try {
              return decodeURIComponent(escape(d.stringify(v)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(v) {
            return d.parse(unescape(encodeURIComponent(v)));
          }
        }, g = i.BufferedBlockAlgorithm = s.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new b.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(v) {
            typeof v == "string" && (v = _.parse(v)), this._data.concat(v), this._nDataBytes += v.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(v) {
            var p, x = this._data, S = x.words, E = x.sigBytes, k = this.blockSize, C = k * 4, A = E / C;
            v ? A = a.ceil(A) : A = a.max((A | 0) - this._minBufferSize, 0);
            var w = A * k, m = a.min(w * 4, E);
            if (w) {
              for (var B = 0; B < w; B += k)
                this._doProcessBlock(S, B);
              p = S.splice(0, w), x.sigBytes -= m;
            }
            return new b.init(p, m);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var v = s.clone.call(this);
            return v._data = this._data.clone(), v;
          },
          _minBufferSize: 0
        });
        i.Hasher = g.extend({
          /**
           * Configuration options.
           */
          cfg: s.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(v) {
            this.cfg = this.cfg.extend(v), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            g.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(v) {
            return this._append(v), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(v) {
            v && this._append(v);
            var p = this._doFinalize();
            return p;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(v) {
            return function(p, x) {
              return new v.init(x).finalize(p);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(v) {
            return function(p, x) {
              return new y.HMAC.init(v, x).finalize(p);
            };
          }
        });
        var y = h.algo = {};
        return h;
      }(Math);
      return t;
    });
  }(ot)), ot.exports;
}
var st = { exports: {} }, Vr;
function Le() {
  return Vr || (Vr = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = a.enc;
        u.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(h) {
            var i = h.words, s = h.sigBytes, b = this._map;
            h.clamp();
            for (var l = [], c = 0; c < s; c += 3)
              for (var d = i[c >>> 2] >>> 24 - c % 4 * 8 & 255, _ = i[c + 1 >>> 2] >>> 24 - (c + 1) % 4 * 8 & 255, g = i[c + 2 >>> 2] >>> 24 - (c + 2) % 4 * 8 & 255, y = d << 16 | _ << 8 | g, v = 0; v < 4 && c + v * 0.75 < s; v++)
                l.push(b.charAt(y >>> 6 * (3 - v) & 63));
            var p = b.charAt(64);
            if (p)
              for (; l.length % 4; )
                l.push(p);
            return l.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(h) {
            var i = h.length, s = this._map, b = this._reverseMap;
            if (!b) {
              b = this._reverseMap = [];
              for (var l = 0; l < s.length; l++)
                b[s.charCodeAt(l)] = l;
            }
            var c = s.charAt(64);
            if (c) {
              var d = h.indexOf(c);
              d !== -1 && (i = d);
            }
            return f(h, i, b);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function f(h, i, s) {
          for (var b = [], l = 0, c = 0; c < i; c++)
            if (c % 4) {
              var d = s[h.charCodeAt(c - 1)] << c % 4 * 2, _ = s[h.charCodeAt(c)] >>> 6 - c % 4 * 2, g = d | _;
              b[l >>> 2] |= g << 24 - l % 4 * 8, l++;
            }
          return o.create(b, l);
        }
      }(), t.enc.Base64;
    });
  }(st)), st.exports;
}
var ft = { exports: {} }, Jr;
function e0() {
  return Jr || (Jr = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function(a) {
        var n = t, o = n.lib, u = o.WordArray, f = o.Hasher, h = n.algo, i = [];
        (function() {
          for (var _ = 0; _ < 64; _++)
            i[_] = a.abs(a.sin(_ + 1)) * 4294967296 | 0;
        })();
        var s = h.MD5 = f.extend({
          _doReset: function() {
            this._hash = new u.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(_, g) {
            for (var y = 0; y < 16; y++) {
              var v = g + y, p = _[v];
              _[v] = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360;
            }
            var x = this._hash.words, S = _[g + 0], E = _[g + 1], k = _[g + 2], C = _[g + 3], A = _[g + 4], w = _[g + 5], m = _[g + 6], B = _[g + 7], z = _[g + 8], T = _[g + 9], O = _[g + 10], L = _[g + 11], K = _[g + 12], $ = _[g + 13], M = _[g + 14], Z = _[g + 15], R = x[0], U = x[1], D = x[2], H = x[3];
            R = b(R, U, D, H, S, 7, i[0]), H = b(H, R, U, D, E, 12, i[1]), D = b(D, H, R, U, k, 17, i[2]), U = b(U, D, H, R, C, 22, i[3]), R = b(R, U, D, H, A, 7, i[4]), H = b(H, R, U, D, w, 12, i[5]), D = b(D, H, R, U, m, 17, i[6]), U = b(U, D, H, R, B, 22, i[7]), R = b(R, U, D, H, z, 7, i[8]), H = b(H, R, U, D, T, 12, i[9]), D = b(D, H, R, U, O, 17, i[10]), U = b(U, D, H, R, L, 22, i[11]), R = b(R, U, D, H, K, 7, i[12]), H = b(H, R, U, D, $, 12, i[13]), D = b(D, H, R, U, M, 17, i[14]), U = b(U, D, H, R, Z, 22, i[15]), R = l(R, U, D, H, E, 5, i[16]), H = l(H, R, U, D, m, 9, i[17]), D = l(D, H, R, U, L, 14, i[18]), U = l(U, D, H, R, S, 20, i[19]), R = l(R, U, D, H, w, 5, i[20]), H = l(H, R, U, D, O, 9, i[21]), D = l(D, H, R, U, Z, 14, i[22]), U = l(U, D, H, R, A, 20, i[23]), R = l(R, U, D, H, T, 5, i[24]), H = l(H, R, U, D, M, 9, i[25]), D = l(D, H, R, U, C, 14, i[26]), U = l(U, D, H, R, z, 20, i[27]), R = l(R, U, D, H, $, 5, i[28]), H = l(H, R, U, D, k, 9, i[29]), D = l(D, H, R, U, B, 14, i[30]), U = l(U, D, H, R, K, 20, i[31]), R = c(R, U, D, H, w, 4, i[32]), H = c(H, R, U, D, z, 11, i[33]), D = c(D, H, R, U, L, 16, i[34]), U = c(U, D, H, R, M, 23, i[35]), R = c(R, U, D, H, E, 4, i[36]), H = c(H, R, U, D, A, 11, i[37]), D = c(D, H, R, U, B, 16, i[38]), U = c(U, D, H, R, O, 23, i[39]), R = c(R, U, D, H, $, 4, i[40]), H = c(H, R, U, D, S, 11, i[41]), D = c(D, H, R, U, C, 16, i[42]), U = c(U, D, H, R, m, 23, i[43]), R = c(R, U, D, H, T, 4, i[44]), H = c(H, R, U, D, K, 11, i[45]), D = c(D, H, R, U, Z, 16, i[46]), U = c(U, D, H, R, k, 23, i[47]), R = d(R, U, D, H, S, 6, i[48]), H = d(H, R, U, D, B, 10, i[49]), D = d(D, H, R, U, M, 15, i[50]), U = d(U, D, H, R, w, 21, i[51]), R = d(R, U, D, H, K, 6, i[52]), H = d(H, R, U, D, C, 10, i[53]), D = d(D, H, R, U, O, 15, i[54]), U = d(U, D, H, R, E, 21, i[55]), R = d(R, U, D, H, z, 6, i[56]), H = d(H, R, U, D, Z, 10, i[57]), D = d(D, H, R, U, m, 15, i[58]), U = d(U, D, H, R, $, 21, i[59]), R = d(R, U, D, H, A, 6, i[60]), H = d(H, R, U, D, L, 10, i[61]), D = d(D, H, R, U, k, 15, i[62]), U = d(U, D, H, R, T, 21, i[63]), x[0] = x[0] + R | 0, x[1] = x[1] + U | 0, x[2] = x[2] + D | 0, x[3] = x[3] + H | 0;
          },
          _doFinalize: function() {
            var _ = this._data, g = _.words, y = this._nDataBytes * 8, v = _.sigBytes * 8;
            g[v >>> 5] |= 128 << 24 - v % 32;
            var p = a.floor(y / 4294967296), x = y;
            g[(v + 64 >>> 9 << 4) + 15] = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360, g[(v + 64 >>> 9 << 4) + 14] = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360, _.sigBytes = (g.length + 1) * 4, this._process();
            for (var S = this._hash, E = S.words, k = 0; k < 4; k++) {
              var C = E[k];
              E[k] = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360;
            }
            return S;
          },
          clone: function() {
            var _ = f.clone.call(this);
            return _._hash = this._hash.clone(), _;
          }
        });
        function b(_, g, y, v, p, x, S) {
          var E = _ + (g & y | ~g & v) + p + S;
          return (E << x | E >>> 32 - x) + g;
        }
        function l(_, g, y, v, p, x, S) {
          var E = _ + (g & v | y & ~v) + p + S;
          return (E << x | E >>> 32 - x) + g;
        }
        function c(_, g, y, v, p, x, S) {
          var E = _ + (g ^ y ^ v) + p + S;
          return (E << x | E >>> 32 - x) + g;
        }
        function d(_, g, y, v, p, x, S) {
          var E = _ + (y ^ (g | ~v)) + p + S;
          return (E << x | E >>> 32 - x) + g;
        }
        n.MD5 = f._createHelper(s), n.HmacMD5 = f._createHmacHelper(s);
      }(Math), t.MD5;
    });
  }(ft)), ft.exports;
}
var ct = { exports: {} }, lt = { exports: {} }, ea;
function Ar() {
  return ea || (ea = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = n.Hasher, f = a.algo, h = [], i = f.SHA1 = u.extend({
          _doReset: function() {
            this._hash = new o.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(s, b) {
            for (var l = this._hash.words, c = l[0], d = l[1], _ = l[2], g = l[3], y = l[4], v = 0; v < 80; v++) {
              if (v < 16)
                h[v] = s[b + v] | 0;
              else {
                var p = h[v - 3] ^ h[v - 8] ^ h[v - 14] ^ h[v - 16];
                h[v] = p << 1 | p >>> 31;
              }
              var x = (c << 5 | c >>> 27) + y + h[v];
              v < 20 ? x += (d & _ | ~d & g) + 1518500249 : v < 40 ? x += (d ^ _ ^ g) + 1859775393 : v < 60 ? x += (d & _ | d & g | _ & g) - 1894007588 : x += (d ^ _ ^ g) - 899497514, y = g, g = _, _ = d << 30 | d >>> 2, d = c, c = x;
            }
            l[0] = l[0] + c | 0, l[1] = l[1] + d | 0, l[2] = l[2] + _ | 0, l[3] = l[3] + g | 0, l[4] = l[4] + y | 0;
          },
          _doFinalize: function() {
            var s = this._data, b = s.words, l = this._nDataBytes * 8, c = s.sigBytes * 8;
            return b[c >>> 5] |= 128 << 24 - c % 32, b[(c + 64 >>> 9 << 4) + 14] = Math.floor(l / 4294967296), b[(c + 64 >>> 9 << 4) + 15] = l, s.sigBytes = b.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var s = u.clone.call(this);
            return s._hash = this._hash.clone(), s;
          }
        });
        a.SHA1 = u._createHelper(i), a.HmacSHA1 = u._createHmacHelper(i);
      }(), t.SHA1;
    });
  }(lt)), lt.exports;
}
var ut = { exports: {} }, ta;
function Br() {
  return ta || (ta = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      (function() {
        var a = t, n = a.lib, o = n.Base, u = a.enc, f = u.Utf8, h = a.algo;
        h.HMAC = o.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(i, s) {
            i = this._hasher = new i.init(), typeof s == "string" && (s = f.parse(s));
            var b = i.blockSize, l = b * 4;
            s.sigBytes > l && (s = i.finalize(s)), s.clamp();
            for (var c = this._oKey = s.clone(), d = this._iKey = s.clone(), _ = c.words, g = d.words, y = 0; y < b; y++)
              _[y] ^= 1549556828, g[y] ^= 909522486;
            c.sigBytes = d.sigBytes = l, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var i = this._hasher;
            i.reset(), i.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(i) {
            return this._hasher.update(i), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(i) {
            var s = this._hasher, b = s.finalize(i);
            s.reset();
            var l = s.finalize(this._oKey.clone().concat(b));
            return l;
          }
        });
      })();
    });
  }(ut)), ut.exports;
}
var ra;
function Pe() {
  return ra || (ra = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Ar(), Br());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.Base, u = n.WordArray, f = a.algo, h = f.MD5, i = f.EvpKDF = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: o.extend({
            keySize: 128 / 32,
            hasher: h,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(s) {
            this.cfg = this.cfg.extend(s);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(s, b) {
            for (var l, c = this.cfg, d = c.hasher.create(), _ = u.create(), g = _.words, y = c.keySize, v = c.iterations; g.length < y; ) {
              l && d.update(l), l = d.update(s).finalize(b), d.reset();
              for (var p = 1; p < v; p++)
                l = d.finalize(l), d.reset();
              _.concat(l);
            }
            return _.sigBytes = y * 4, _;
          }
        });
        a.EvpKDF = function(s, b, l) {
          return i.create(l).compute(s, b);
        };
      }(), t.EvpKDF;
    });
  }(ct)), ct.exports;
}
var dt = { exports: {} }, aa;
function Y() {
  return aa || (aa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Pe());
    })(I, function(t) {
      t.lib.Cipher || function(a) {
        var n = t, o = n.lib, u = o.Base, f = o.WordArray, h = o.BufferedBlockAlgorithm, i = n.enc;
        i.Utf8;
        var s = i.Base64, b = n.algo, l = b.EvpKDF, c = o.Cipher = h.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: u.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(w, m) {
            return this.create(this._ENC_XFORM_MODE, w, m);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(w, m) {
            return this.create(this._DEC_XFORM_MODE, w, m);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(w, m, B) {
            this.cfg = this.cfg.extend(B), this._xformMode = w, this._key = m, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            h.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(w) {
            return this._append(w), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(w) {
            w && this._append(w);
            var m = this._doFinalize();
            return m;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function w(m) {
              return typeof m == "string" ? A : E;
            }
            return function(m) {
              return {
                encrypt: function(B, z, T) {
                  return w(z).encrypt(m, B, z, T);
                },
                decrypt: function(B, z, T) {
                  return w(z).decrypt(m, B, z, T);
                }
              };
            };
          }()
        });
        o.StreamCipher = c.extend({
          _doFinalize: function() {
            var w = this._process(!0);
            return w;
          },
          blockSize: 1
        });
        var d = n.mode = {}, _ = o.BlockCipherMode = u.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(w, m) {
            return this.Encryptor.create(w, m);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(w, m) {
            return this.Decryptor.create(w, m);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(w, m) {
            this._cipher = w, this._iv = m;
          }
        }), g = d.CBC = function() {
          var w = _.extend();
          w.Encryptor = w.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, z) {
              var T = this._cipher, O = T.blockSize;
              m.call(this, B, z, O), T.encryptBlock(B, z), this._prevBlock = B.slice(z, z + O);
            }
          }), w.Decryptor = w.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, z) {
              var T = this._cipher, O = T.blockSize, L = B.slice(z, z + O);
              T.decryptBlock(B, z), m.call(this, B, z, O), this._prevBlock = L;
            }
          });
          function m(B, z, T) {
            var O, L = this._iv;
            L ? (O = L, this._iv = a) : O = this._prevBlock;
            for (var K = 0; K < T; K++)
              B[z + K] ^= O[K];
          }
          return w;
        }(), y = n.pad = {}, v = y.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(w, m) {
            for (var B = m * 4, z = B - w.sigBytes % B, T = z << 24 | z << 16 | z << 8 | z, O = [], L = 0; L < z; L += 4)
              O.push(T);
            var K = f.create(O, z);
            w.concat(K);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(w) {
            var m = w.words[w.sigBytes - 1 >>> 2] & 255;
            w.sigBytes -= m;
          }
        };
        o.BlockCipher = c.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: c.cfg.extend({
            mode: g,
            padding: v
          }),
          reset: function() {
            var w;
            c.reset.call(this);
            var m = this.cfg, B = m.iv, z = m.mode;
            this._xformMode == this._ENC_XFORM_MODE ? w = z.createEncryptor : (w = z.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == w ? this._mode.init(this, B && B.words) : (this._mode = w.call(z, this, B && B.words), this._mode.__creator = w);
          },
          _doProcessBlock: function(w, m) {
            this._mode.processBlock(w, m);
          },
          _doFinalize: function() {
            var w, m = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (m.pad(this._data, this.blockSize), w = this._process(!0)) : (w = this._process(!0), m.unpad(w)), w;
          },
          blockSize: 128 / 32
        });
        var p = o.CipherParams = u.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(w) {
            this.mixIn(w);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(w) {
            return (w || this.formatter).stringify(this);
          }
        }), x = n.format = {}, S = x.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(w) {
            var m, B = w.ciphertext, z = w.salt;
            return z ? m = f.create([1398893684, 1701076831]).concat(z).concat(B) : m = B, m.toString(s);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(w) {
            var m, B = s.parse(w), z = B.words;
            return z[0] == 1398893684 && z[1] == 1701076831 && (m = f.create(z.slice(2, 4)), z.splice(0, 4), B.sigBytes -= 16), p.create({ ciphertext: B, salt: m });
          }
        }, E = o.SerializableCipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: u.extend({
            format: S
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(w, m, B, z) {
            z = this.cfg.extend(z);
            var T = w.createEncryptor(B, z), O = T.finalize(m), L = T.cfg;
            return p.create({
              ciphertext: O,
              key: B,
              iv: L.iv,
              algorithm: w,
              mode: L.mode,
              padding: L.padding,
              blockSize: w.blockSize,
              formatter: z.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(w, m, B, z) {
            z = this.cfg.extend(z), m = this._parse(m, z.format);
            var T = w.createDecryptor(B, z).finalize(m.ciphertext);
            return T;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(w, m) {
            return typeof w == "string" ? m.parse(w, this) : w;
          }
        }), k = n.kdf = {}, C = k.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(w, m, B, z) {
            z || (z = f.random(64 / 8));
            var T = l.create({ keySize: m + B }).compute(w, z), O = f.create(T.words.slice(m), B * 4);
            return T.sigBytes = m * 4, p.create({ key: T, iv: O, salt: z });
          }
        }, A = o.PasswordBasedCipher = E.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: E.cfg.extend({
            kdf: C
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(w, m, B, z) {
            z = this.cfg.extend(z);
            var T = z.kdf.execute(B, w.keySize, w.ivSize);
            z.iv = T.iv;
            var O = E.encrypt.call(this, w, m, T.key, z);
            return O.mixIn(T), O;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(w, m, B, z) {
            z = this.cfg.extend(z), m = this._parse(m, z.format);
            var T = z.kdf.execute(B, w.keySize, w.ivSize, m.salt);
            z.iv = T.iv;
            var O = E.decrypt.call(this, w, m, T.key, z);
            return O;
          }
        });
      }();
    });
  }(dt)), dt.exports;
}
(function(e, r) {
  (function(t, a, n) {
    e.exports = a(P(), Le(), e0(), Pe(), Y());
  })(I, function(t) {
    return function() {
      var a = t, n = a.lib, o = n.BlockCipher, u = a.algo, f = [], h = [], i = [], s = [], b = [], l = [], c = [], d = [], _ = [], g = [];
      (function() {
        for (var p = [], x = 0; x < 256; x++)
          x < 128 ? p[x] = x << 1 : p[x] = x << 1 ^ 283;
        for (var S = 0, E = 0, x = 0; x < 256; x++) {
          var k = E ^ E << 1 ^ E << 2 ^ E << 3 ^ E << 4;
          k = k >>> 8 ^ k & 255 ^ 99, f[S] = k, h[k] = S;
          var C = p[S], A = p[C], w = p[A], m = p[k] * 257 ^ k * 16843008;
          i[S] = m << 24 | m >>> 8, s[S] = m << 16 | m >>> 16, b[S] = m << 8 | m >>> 24, l[S] = m;
          var m = w * 16843009 ^ A * 65537 ^ C * 257 ^ S * 16843008;
          c[k] = m << 24 | m >>> 8, d[k] = m << 16 | m >>> 16, _[k] = m << 8 | m >>> 24, g[k] = m, S ? (S = C ^ p[p[p[w ^ C]]], E ^= p[p[E]]) : S = E = 1;
        }
      })();
      var y = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], v = u.AES = o.extend({
        _doReset: function() {
          var p;
          if (!(this._nRounds && this._keyPriorReset === this._key)) {
            for (var x = this._keyPriorReset = this._key, S = x.words, E = x.sigBytes / 4, k = this._nRounds = E + 6, C = (k + 1) * 4, A = this._keySchedule = [], w = 0; w < C; w++)
              w < E ? A[w] = S[w] : (p = A[w - 1], w % E ? E > 6 && w % E == 4 && (p = f[p >>> 24] << 24 | f[p >>> 16 & 255] << 16 | f[p >>> 8 & 255] << 8 | f[p & 255]) : (p = p << 8 | p >>> 24, p = f[p >>> 24] << 24 | f[p >>> 16 & 255] << 16 | f[p >>> 8 & 255] << 8 | f[p & 255], p ^= y[w / E | 0] << 24), A[w] = A[w - E] ^ p);
            for (var m = this._invKeySchedule = [], B = 0; B < C; B++) {
              var w = C - B;
              if (B % 4)
                var p = A[w];
              else
                var p = A[w - 4];
              B < 4 || w <= 4 ? m[B] = p : m[B] = c[f[p >>> 24]] ^ d[f[p >>> 16 & 255]] ^ _[f[p >>> 8 & 255]] ^ g[f[p & 255]];
            }
          }
        },
        encryptBlock: function(p, x) {
          this._doCryptBlock(p, x, this._keySchedule, i, s, b, l, f);
        },
        decryptBlock: function(p, x) {
          var S = p[x + 1];
          p[x + 1] = p[x + 3], p[x + 3] = S, this._doCryptBlock(p, x, this._invKeySchedule, c, d, _, g, h);
          var S = p[x + 1];
          p[x + 1] = p[x + 3], p[x + 3] = S;
        },
        _doCryptBlock: function(p, x, S, E, k, C, A, w) {
          for (var m = this._nRounds, B = p[x] ^ S[0], z = p[x + 1] ^ S[1], T = p[x + 2] ^ S[2], O = p[x + 3] ^ S[3], L = 4, K = 1; K < m; K++) {
            var $ = E[B >>> 24] ^ k[z >>> 16 & 255] ^ C[T >>> 8 & 255] ^ A[O & 255] ^ S[L++], M = E[z >>> 24] ^ k[T >>> 16 & 255] ^ C[O >>> 8 & 255] ^ A[B & 255] ^ S[L++], Z = E[T >>> 24] ^ k[O >>> 16 & 255] ^ C[B >>> 8 & 255] ^ A[z & 255] ^ S[L++], R = E[O >>> 24] ^ k[B >>> 16 & 255] ^ C[z >>> 8 & 255] ^ A[T & 255] ^ S[L++];
            B = $, z = M, T = Z, O = R;
          }
          var $ = (w[B >>> 24] << 24 | w[z >>> 16 & 255] << 16 | w[T >>> 8 & 255] << 8 | w[O & 255]) ^ S[L++], M = (w[z >>> 24] << 24 | w[T >>> 16 & 255] << 16 | w[O >>> 8 & 255] << 8 | w[B & 255]) ^ S[L++], Z = (w[T >>> 24] << 24 | w[O >>> 16 & 255] << 16 | w[B >>> 8 & 255] << 8 | w[z & 255]) ^ S[L++], R = (w[O >>> 24] << 24 | w[B >>> 16 & 255] << 16 | w[z >>> 8 & 255] << 8 | w[T & 255]) ^ S[L++];
          p[x] = $, p[x + 1] = M, p[x + 2] = Z, p[x + 3] = R;
        },
        keySize: 256 / 32
      });
      a.AES = o._createHelper(v);
    }(), t.AES;
  });
})(Mn);
var Wn = Mn.exports;
const na = /* @__PURE__ */ Ue(Wn);
var Kn = { exports: {} };
(function(e, r) {
  (function(t, a) {
    e.exports = a(P());
  })(I, function(t) {
    return t.enc.Utf8;
  });
})(Kn);
var _o = Kn.exports;
const u0 = /* @__PURE__ */ Ue(_o);
var jn = { exports: {} };
(function(e, r) {
  (function(t, a) {
    e.exports = a(P());
  })(I, function(t) {
    return t.enc.Hex;
  });
})(jn);
var vo = jn.exports;
const po = /* @__PURE__ */ Ue(vo);
var go = Le();
const bo = /* @__PURE__ */ Ue(go);
var Xn = { exports: {} };
(function(e, r) {
  (function(t, a, n) {
    e.exports = a(P(), Y());
  })(I, function(t) {
    return t.mode.ECB = function() {
      var a = t.lib.BlockCipherMode.extend();
      return a.Encryptor = a.extend({
        processBlock: function(n, o) {
          this._cipher.encryptBlock(n, o);
        }
      }), a.Decryptor = a.extend({
        processBlock: function(n, o) {
          this._cipher.decryptBlock(n, o);
        }
      }), a;
    }(), t.mode.ECB;
  });
})(Xn);
var Gn = Xn.exports;
const ia = /* @__PURE__ */ Ue(Gn);
var Yn = { exports: {} };
(function(e, r) {
  (function(t, a, n) {
    e.exports = a(P(), Y());
  })(I, function(t) {
    return t.pad.Pkcs7;
  });
})(Yn);
var wo = Yn.exports;
const oa = /* @__PURE__ */ Ue(wo), yo = (e) => {
  Je().set("UserManagerConfig", e);
}, w0 = () => Je().get("UserManagerConfig");
class v0 {
  constructor() {
    this._aesKey = "61B23A1FC7814F6CB6B23882018A68DD", this._iv = "518AE66C8EB44ACE", this._cookieName = "do", this._cookiePath = "/", this._domain = window.location.href.indexOf("designorder.cn") !== -1 ? "designorder.cn" : void 0, this._getFullCookieName = () => `${this._cookieName}.${w0().env}`;
  }
  getUserInfo() {
    try {
      const o = We.get(this._getFullCookieName());
      if (!o || o === "")
        return;
      var r = po.parse(o), t = bo.stringify(r), a = na.decrypt(t, u0.parse(this._aesKey), {
        iv: u0.parse(this._iv),
        mode: ia,
        padding: oa
      }), n = JSON.parse(a.toString(u0));
      return n;
    } catch (o) {
      console.error(o), We.remove(this._getFullCookieName(), {
        path: this._cookiePath,
        domain: this._domain
      });
      return;
    }
  }
  setUserInfo(r) {
    if (r) {
      var t = na.encrypt(JSON.stringify(r), u0.parse(this._aesKey), {
        iv: u0.parse(this._iv),
        mode: ia,
        padding: oa
      }).ciphertext.toString();
      We.set(this._getFullCookieName(), t, { expires: 30, path: this._cookiePath, domain: this._domain });
    } else
      We.remove(this._getFullCookieName(), {
        path: this._cookiePath,
        domain: this._domain
      });
    return Promise.resolve(!0);
  }
  setUserInfoString(r) {
    We.set(this._getFullCookieName(), r, { expires: 30, path: this._cookiePath, domain: this._domain });
  }
  getUserInfoString() {
    return We.get(this._getFullCookieName());
  }
}
const Z0 = (e) => {
  Je().set("LoginUser", e);
}, Ee = () => {
  let e = Je().get("LoginUser");
  return e || (e = new v0().getUserInfo(), e && Z0(e)), e;
};
class mo {
  constructor(r) {
    this._logout = () => {
      this._userManager.logout(), clearTimeout(this._checkUserLoginPtr), clearTimeout(this._keepAlivePtr);
    }, this._checkUserLogin = () => {
      const t = this._cookieStorage.getUserInfo();
      if (!t) {
        this._logout();
        return;
      }
      const a = Ee();
      if (a && t && a.user.id !== t.user.id) {
        this._logout();
        return;
      }
      this._checkUserLoginPtr = window.setTimeout(this._checkUserLogin, 300);
    }, this._keepAlive = async () => {
      try {
        fi.keepAlive(), this._keepAlivePtr = window.setTimeout(this._checkUserLogin, 1e3 * 60 * 10);
      } catch {
        this._logout();
        return;
      }
    }, this._userManager = r, this._cookieStorage = new v0(), this._checkUserLogin(), this._keepAlivePtr = window.setTimeout(this._keepAlive, 1e3 * 60 * 10);
  }
}
var Rr = { exports: {} }, Qn = function(r, t) {
  return function() {
    for (var n = new Array(arguments.length), o = 0; o < n.length; o++)
      n[o] = arguments[o];
    return r.apply(t, n);
  };
}, ko = Qn, Ne = Object.prototype.toString;
function zr(e) {
  return Ne.call(e) === "[object Array]";
}
function vr(e) {
  return typeof e > "u";
}
function So(e) {
  return e !== null && !vr(e) && e.constructor !== null && !vr(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Eo(e) {
  return Ne.call(e) === "[object ArrayBuffer]";
}
function Co(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function Ao(e) {
  var r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && e.buffer instanceof ArrayBuffer, r;
}
function Bo(e) {
  return typeof e == "string";
}
function Ro(e) {
  return typeof e == "number";
}
function Vn(e) {
  return e !== null && typeof e == "object";
}
function M0(e) {
  if (Ne.call(e) !== "[object Object]")
    return !1;
  var r = Object.getPrototypeOf(e);
  return r === null || r === Object.prototype;
}
function zo(e) {
  return Ne.call(e) === "[object Date]";
}
function Ho(e) {
  return Ne.call(e) === "[object File]";
}
function Uo(e) {
  return Ne.call(e) === "[object Blob]";
}
function Jn(e) {
  return Ne.call(e) === "[object Function]";
}
function Do(e) {
  return Vn(e) && Jn(e.pipe);
}
function To(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function Oo(e) {
  return e.replace(/^\s*/, "").replace(/\s*$/, "");
}
function Io() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Hr(e, r) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), zr(e))
      for (var t = 0, a = e.length; t < a; t++)
        r.call(null, e[t], t, e);
    else
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && r.call(null, e[n], n, e);
}
function pr() {
  var e = {};
  function r(n, o) {
    M0(e[o]) && M0(n) ? e[o] = pr(e[o], n) : M0(n) ? e[o] = pr({}, n) : zr(n) ? e[o] = n.slice() : e[o] = n;
  }
  for (var t = 0, a = arguments.length; t < a; t++)
    Hr(arguments[t], r);
  return e;
}
function Fo(e, r, t) {
  return Hr(r, function(n, o) {
    t && typeof n == "function" ? e[o] = ko(n, t) : e[o] = n;
  }), e;
}
function Lo(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var fe = {
  isArray: zr,
  isArrayBuffer: Eo,
  isBuffer: So,
  isFormData: Co,
  isArrayBufferView: Ao,
  isString: Bo,
  isNumber: Ro,
  isObject: Vn,
  isPlainObject: M0,
  isUndefined: vr,
  isDate: zo,
  isFile: Ho,
  isBlob: Uo,
  isFunction: Jn,
  isStream: Do,
  isURLSearchParams: To,
  isStandardBrowserEnv: Io,
  forEach: Hr,
  merge: pr,
  extend: Fo,
  trim: Oo,
  stripBOM: Lo
}, Ke = fe;
function sa(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var ei = function(r, t, a) {
  if (!t)
    return r;
  var n;
  if (a)
    n = a(t);
  else if (Ke.isURLSearchParams(t))
    n = t.toString();
  else {
    var o = [];
    Ke.forEach(t, function(h, i) {
      h === null || typeof h > "u" || (Ke.isArray(h) ? i = i + "[]" : h = [h], Ke.forEach(h, function(b) {
        Ke.isDate(b) ? b = b.toISOString() : Ke.isObject(b) && (b = JSON.stringify(b)), o.push(sa(i) + "=" + sa(b));
      }));
    }), n = o.join("&");
  }
  if (n) {
    var u = r.indexOf("#");
    u !== -1 && (r = r.slice(0, u)), r += (r.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return r;
}, Po = fe;
function Y0() {
  this.handlers = [];
}
Y0.prototype.use = function(r, t) {
  return this.handlers.push({
    fulfilled: r,
    rejected: t
  }), this.handlers.length - 1;
};
Y0.prototype.eject = function(r) {
  this.handlers[r] && (this.handlers[r] = null);
};
Y0.prototype.forEach = function(r) {
  Po.forEach(this.handlers, function(a) {
    a !== null && r(a);
  });
};
var No = Y0, qo = fe, $o = function(r, t, a) {
  return qo.forEach(a, function(o) {
    r = o(r, t);
  }), r;
}, xt, fa;
function ti() {
  return fa || (fa = 1, xt = function(r) {
    return !!(r && r.__CANCEL__);
  }), xt;
}
var Zo = fe, Mo = function(r, t) {
  Zo.forEach(r, function(n, o) {
    o !== t && o.toUpperCase() === t.toUpperCase() && (r[t] = n, delete r[o]);
  });
}, ht, ca;
function Wo() {
  return ca || (ca = 1, ht = function(r, t, a, n, o) {
    return r.config = t, a && (r.code = a), r.request = n, r.response = o, r.isAxiosError = !0, r.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, r;
  }), ht;
}
var _t, la;
function ri() {
  if (la)
    return _t;
  la = 1;
  var e = Wo();
  return _t = function(t, a, n, o, u) {
    var f = new Error(t);
    return e(f, a, n, o, u);
  }, _t;
}
var vt, ua;
function Ko() {
  if (ua)
    return vt;
  ua = 1;
  var e = ri();
  return vt = function(t, a, n) {
    var o = n.config.validateStatus;
    !n.status || !o || o(n.status) ? t(n) : a(e(
      "Request failed with status code " + n.status,
      n.config,
      null,
      n.request,
      n
    ));
  }, vt;
}
var pt, da;
function jo() {
  if (da)
    return pt;
  da = 1;
  var e = fe;
  return pt = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(a, n, o, u, f, h) {
          var i = [];
          i.push(a + "=" + encodeURIComponent(n)), e.isNumber(o) && i.push("expires=" + new Date(o).toGMTString()), e.isString(u) && i.push("path=" + u), e.isString(f) && i.push("domain=" + f), h === !0 && i.push("secure"), document.cookie = i.join("; ");
        },
        read: function(a) {
          var n = document.cookie.match(new RegExp("(^|;\\s*)(" + a + ")=([^;]*)"));
          return n ? decodeURIComponent(n[3]) : null;
        },
        remove: function(a) {
          this.write(a, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), pt;
}
var gt, xa;
function Xo() {
  return xa || (xa = 1, gt = function(r) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(r);
  }), gt;
}
var bt, ha;
function Go() {
  return ha || (ha = 1, bt = function(r, t) {
    return t ? r.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : r;
  }), bt;
}
var wt, _a;
function Yo() {
  if (_a)
    return wt;
  _a = 1;
  var e = Xo(), r = Go();
  return wt = function(a, n) {
    return a && !e(n) ? r(a, n) : n;
  }, wt;
}
var yt, va;
function Qo() {
  if (va)
    return yt;
  va = 1;
  var e = fe, r = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return yt = function(a) {
    var n = {}, o, u, f;
    return a && e.forEach(a.split(`
`), function(i) {
      if (f = i.indexOf(":"), o = e.trim(i.substr(0, f)).toLowerCase(), u = e.trim(i.substr(f + 1)), o) {
        if (n[o] && r.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? n[o] = (n[o] ? n[o] : []).concat([u]) : n[o] = n[o] ? n[o] + ", " + u : u;
      }
    }), n;
  }, yt;
}
var mt, pa;
function Vo() {
  if (pa)
    return mt;
  pa = 1;
  var e = fe;
  return mt = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), a = document.createElement("a"), n;
      function o(u) {
        var f = u;
        return t && (a.setAttribute("href", f), f = a.href), a.setAttribute("href", f), {
          href: a.href,
          protocol: a.protocol ? a.protocol.replace(/:$/, "") : "",
          host: a.host,
          search: a.search ? a.search.replace(/^\?/, "") : "",
          hash: a.hash ? a.hash.replace(/^#/, "") : "",
          hostname: a.hostname,
          port: a.port,
          pathname: a.pathname.charAt(0) === "/" ? a.pathname : "/" + a.pathname
        };
      }
      return n = o(window.location.href), function(f) {
        var h = e.isString(f) ? o(f) : f;
        return h.protocol === n.protocol && h.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), mt;
}
var kt, ga;
function ba() {
  if (ga)
    return kt;
  ga = 1;
  var e = fe, r = Ko(), t = jo(), a = ei, n = Yo(), o = Qo(), u = Vo(), f = ri();
  return kt = function(i) {
    return new Promise(function(b, l) {
      var c = i.data, d = i.headers;
      e.isFormData(c) && delete d["Content-Type"];
      var _ = new XMLHttpRequest();
      if (i.auth) {
        var g = i.auth.username || "", y = i.auth.password ? unescape(encodeURIComponent(i.auth.password)) : "";
        d.Authorization = "Basic " + btoa(g + ":" + y);
      }
      var v = n(i.baseURL, i.url);
      if (_.open(i.method.toUpperCase(), a(v, i.params, i.paramsSerializer), !0), _.timeout = i.timeout, _.onreadystatechange = function() {
        if (!(!_ || _.readyState !== 4) && !(_.status === 0 && !(_.responseURL && _.responseURL.indexOf("file:") === 0))) {
          var S = "getAllResponseHeaders" in _ ? o(_.getAllResponseHeaders()) : null, E = !i.responseType || i.responseType === "text" ? _.responseText : _.response, k = {
            data: E,
            status: _.status,
            statusText: _.statusText,
            headers: S,
            config: i,
            request: _
          };
          r(b, l, k), _ = null;
        }
      }, _.onabort = function() {
        _ && (l(f("Request aborted", i, "ECONNABORTED", _)), _ = null);
      }, _.onerror = function() {
        l(f("Network Error", i, null, _)), _ = null;
      }, _.ontimeout = function() {
        var S = "timeout of " + i.timeout + "ms exceeded";
        i.timeoutErrorMessage && (S = i.timeoutErrorMessage), l(f(
          S,
          i,
          "ECONNABORTED",
          _
        )), _ = null;
      }, e.isStandardBrowserEnv()) {
        var p = (i.withCredentials || u(v)) && i.xsrfCookieName ? t.read(i.xsrfCookieName) : void 0;
        p && (d[i.xsrfHeaderName] = p);
      }
      if ("setRequestHeader" in _ && e.forEach(d, function(S, E) {
        typeof c > "u" && E.toLowerCase() === "content-type" ? delete d[E] : _.setRequestHeader(E, S);
      }), e.isUndefined(i.withCredentials) || (_.withCredentials = !!i.withCredentials), i.responseType)
        try {
          _.responseType = i.responseType;
        } catch (x) {
          if (i.responseType !== "json")
            throw x;
        }
      typeof i.onDownloadProgress == "function" && _.addEventListener("progress", i.onDownloadProgress), typeof i.onUploadProgress == "function" && _.upload && _.upload.addEventListener("progress", i.onUploadProgress), i.cancelToken && i.cancelToken.promise.then(function(S) {
        _ && (_.abort(), l(S), _ = null);
      }), c || (c = null), _.send(c);
    });
  }, kt;
}
var re = fe, wa = Mo, Jo = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function ya(e, r) {
  !re.isUndefined(e) && re.isUndefined(e["Content-Type"]) && (e["Content-Type"] = r);
}
function es() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = ba()), e;
}
var Q0 = {
  adapter: es(),
  transformRequest: [function(r, t) {
    return wa(t, "Accept"), wa(t, "Content-Type"), re.isFormData(r) || re.isArrayBuffer(r) || re.isBuffer(r) || re.isStream(r) || re.isFile(r) || re.isBlob(r) ? r : re.isArrayBufferView(r) ? r.buffer : re.isURLSearchParams(r) ? (ya(t, "application/x-www-form-urlencoded;charset=utf-8"), r.toString()) : re.isObject(r) ? (ya(t, "application/json;charset=utf-8"), JSON.stringify(r)) : r;
  }],
  transformResponse: [function(r) {
    if (typeof r == "string")
      try {
        r = JSON.parse(r);
      } catch {
      }
    return r;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  }
};
Q0.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
re.forEach(["delete", "get", "head"], function(r) {
  Q0.headers[r] = {};
});
re.forEach(["post", "put", "patch"], function(r) {
  Q0.headers[r] = re.merge(Jo);
});
var ai = Q0, ma = fe, St = $o, ts = ti(), rs = ai;
function Et(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var as = function(r) {
  Et(r), r.headers = r.headers || {}, r.data = St(
    r.data,
    r.headers,
    r.transformRequest
  ), r.headers = ma.merge(
    r.headers.common || {},
    r.headers[r.method] || {},
    r.headers
  ), ma.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(n) {
      delete r.headers[n];
    }
  );
  var t = r.adapter || rs.adapter;
  return t(r).then(function(n) {
    return Et(r), n.data = St(
      n.data,
      n.headers,
      r.transformResponse
    ), n;
  }, function(n) {
    return ts(n) || (Et(r), n && n.response && (n.response.data = St(
      n.response.data,
      n.response.headers,
      r.transformResponse
    ))), Promise.reject(n);
  });
}, V = fe, ni = function(r, t) {
  t = t || {};
  var a = {}, n = ["url", "method", "data"], o = ["headers", "auth", "proxy", "params"], u = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], f = ["validateStatus"];
  function h(l, c) {
    return V.isPlainObject(l) && V.isPlainObject(c) ? V.merge(l, c) : V.isPlainObject(c) ? V.merge({}, c) : V.isArray(c) ? c.slice() : c;
  }
  function i(l) {
    V.isUndefined(t[l]) ? V.isUndefined(r[l]) || (a[l] = h(void 0, r[l])) : a[l] = h(r[l], t[l]);
  }
  V.forEach(n, function(c) {
    V.isUndefined(t[c]) || (a[c] = h(void 0, t[c]));
  }), V.forEach(o, i), V.forEach(u, function(c) {
    V.isUndefined(t[c]) ? V.isUndefined(r[c]) || (a[c] = h(void 0, r[c])) : a[c] = h(void 0, t[c]);
  }), V.forEach(f, function(c) {
    c in t ? a[c] = h(r[c], t[c]) : c in r && (a[c] = h(void 0, r[c]));
  });
  var s = n.concat(o).concat(u).concat(f), b = Object.keys(r).concat(Object.keys(t)).filter(function(c) {
    return s.indexOf(c) === -1;
  });
  return V.forEach(b, i), a;
}, ii = fe, ns = ei, ka = No, is = as, V0 = ni;
function R0(e) {
  this.defaults = e, this.interceptors = {
    request: new ka(),
    response: new ka()
  };
}
R0.prototype.request = function(r) {
  typeof r == "string" ? (r = arguments[1] || {}, r.url = arguments[0]) : r = r || {}, r = V0(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var t = [is, void 0], a = Promise.resolve(r);
  for (this.interceptors.request.forEach(function(o) {
    t.unshift(o.fulfilled, o.rejected);
  }), this.interceptors.response.forEach(function(o) {
    t.push(o.fulfilled, o.rejected);
  }); t.length; )
    a = a.then(t.shift(), t.shift());
  return a;
};
R0.prototype.getUri = function(r) {
  return r = V0(this.defaults, r), ns(r.url, r.params, r.paramsSerializer).replace(/^\?/, "");
};
ii.forEach(["delete", "get", "head", "options"], function(r) {
  R0.prototype[r] = function(t, a) {
    return this.request(V0(a || {}, {
      method: r,
      url: t,
      data: (a || {}).data
    }));
  };
});
ii.forEach(["post", "put", "patch"], function(r) {
  R0.prototype[r] = function(t, a, n) {
    return this.request(V0(n || {}, {
      method: r,
      url: t,
      data: a
    }));
  };
});
var os = R0, Ct, Sa;
function oi() {
  if (Sa)
    return Ct;
  Sa = 1;
  function e(r) {
    this.message = r;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Ct = e, Ct;
}
var At, Ea;
function ss() {
  if (Ea)
    return At;
  Ea = 1;
  var e = oi();
  function r(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var a;
    this.promise = new Promise(function(u) {
      a = u;
    });
    var n = this;
    t(function(u) {
      n.reason || (n.reason = new e(u), a(n.reason));
    });
  }
  return r.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, r.source = function() {
    var a, n = new r(function(u) {
      a = u;
    });
    return {
      token: n,
      cancel: a
    };
  }, At = r, At;
}
var Bt, Ca;
function fs() {
  return Ca || (Ca = 1, Bt = function(r) {
    return function(a) {
      return r.apply(null, a);
    };
  }), Bt;
}
var Rt, Aa;
function cs() {
  return Aa || (Aa = 1, Rt = function(r) {
    return typeof r == "object" && r.isAxiosError === !0;
  }), Rt;
}
var Ba = fe, ls = Qn, W0 = os, us = ni, ds = ai;
function si(e) {
  var r = new W0(e), t = ls(W0.prototype.request, r);
  return Ba.extend(t, W0.prototype, r), Ba.extend(t, r), t;
}
var he = si(ds);
he.Axios = W0;
he.create = function(r) {
  return si(us(he.defaults, r));
};
he.Cancel = oi();
he.CancelToken = ss();
he.isCancel = ti();
he.all = function(r) {
  return Promise.all(r);
};
he.spread = fs();
he.isAxiosError = cs();
Rr.exports = he;
Rr.exports.default = he;
var xs = Rr.exports, hs = xs;
const J = /* @__PURE__ */ Ue(hs);
class _s {
  get baseUrl() {
    var r;
    return (r = w0()) == null ? void 0 : r.baseUrl;
  }
  get token() {
    var r;
    return (r = Ee()) == null ? void 0 : r.token;
  }
  GetSingnature() {
    return this._signature;
  }
  SetSingnature(r) {
    this._signature = r;
  }
  FsApiServiceImpl() {
  }
  getHeaders() {
    return {
      headers: {
        "X-ACCESS-TOKEN": this.token,
        "content-type": "application/json;charset=UTF-8"
      }
    };
  }
  openIn() {
    return !!window.h5sdk;
  }
  async config(r) {
    try {
      var t = await window.h5sdk.config({
        appId: r.appid,
        timestamp: r.timestamp,
        nonceStr: r.noncestr,
        signature: r.signature,
        jsApiList: [],
        //鉴权成功回调
        onSuccess: () => {
        },
        //鉴权失败回调
        onFail: (a) => {
          throw `config failed: ${JSON.stringify(a)}`;
        }
      });
      return tt.showToast({
        title: "鉴权成功",
        icon: "success",
        duration: 3e3
      }), t;
    } catch {
    }
  }
  /**
   * 从飞书客户端获取临时授权码，交给后端获取用户信息
   * @returns 临时授权码
   */
  requestAuthCode() {
    var r, t;
    if (!((r = this._signature) != null && r.appid)) {
      console.error("未获取到appid!");
      return;
    }
    try {
      tt.requestAuthCode({
        appId: (t = this._signature) == null ? void 0 : t.appid,
        // requestAuthCode API 调用成功回调
        success(a) {
          if (a && a.code) {
            var n = Ae.GetSingnature();
            n && Ae.SetSingnature({ ...n, code: a.code });
          }
        },
        // requestAuthCode API 调用失败回调
        fail(a) {
          console.log("getCode failed, err:", JSON.stringify(a));
        }
      });
    } catch (a) {
      console.error(a);
    }
  }
  /**
   * 根据飞书返回的临时授权码
   * @param code 临时授权码
   * @returns
   */
  async getUserInfo() {
    this.requestAuthCode(), await Ra(500);
    var r = Ae.GetSingnature();
    if (r && r.code) {
      const t = `${this.baseUrl}/jeecg-boot/do/api/getFsUserInfo?code=${r.code}`, a = await J.get(t, this.getHeaders());
      if (a.data.code === 200)
        return a.data.result;
      throw new Error(a.data.message);
    }
  }
  /**
   * 对网页进行飞书的授权
   * @param url 需要授权认证的网页Url
   * @returns 授权签名
   */
  async getFsSignature(r) {
    const t = `${this.baseUrl}/jeecg-boot/do/api/fsSignature?url=${r}`, a = await J.get(t, this.getHeaders());
    if (a.data.code === 200)
      return this.SetSingnature(a.data.result), a.data.result;
    throw new Error(a.data.message);
  }
  /**
   * 根据飞书文件
   * @param code 临时授权码
   * @returns
   */
  async getFsFile() {
    this.requestAuthCode(), await Ra(500);
    var r = Ae.GetSingnature();
    if (r && r.code) {
      const t = `${this.baseUrl}/jeecg-boot/do/api/getFsUserInfo?code=${r.code}`, a = await J.get(t, this.getHeaders());
      if (a.data.code === 200)
        return a.data.result;
      throw new Error(a.data.message);
    }
  }
}
const Ae = new _s();
function Ra(e) {
  return new Promise((r) => setTimeout(r, e));
}
class vs {
  constructor() {
    this._init = !1, this.openIn = () => Ae.openIn(), this.getUserInfo = async () => await Ae.getUserInfo();
  }
  /**
   * 初始化鉴权
   */
  async init() {
    this._init || console.log("鉴权结果 :>> ", await this.apiAuth());
  }
  async apiAuth() {
    const r = encodeURIComponent(location.href.split("#")[0]);
    var t = await Ae.getFsSignature(r);
    if (t) {
      var a = await Ae.config(t);
      if (a.msg === "success")
        return !0;
    }
    return !1;
  }
}
const d0 = new vs();
class ps {
  get baseUrl() {
    var r;
    return (r = w0()) == null ? void 0 : r.baseUrl;
  }
  get token() {
    var r;
    return (r = Ee()) == null ? void 0 : r.token;
  }
  JeecgAuthServiceImpl() {
  }
  getHeaders() {
    return {
      headers: {
        "X-ACCESS-TOKEN": this.token,
        "content-type": "application/json;charset=UTF-8"
      }
    };
  }
  async getRandomCode(r) {
    const t = `${this.baseUrl}/jeecg-boot/sys/randomImage/${r}`;
    return await J.get(t).then((a) => a.data.result);
  }
  async login(r) {
    const t = `${this.baseUrl}/jeecg-boot/sys/login/`, a = await J.post(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.result;
    throw new Error(a.data.message);
  }
  async resetUserPassword(r) {
    const t = `${this.baseUrl}/jeecg-boot/sys/resetUserPassword/`, a = await J.post(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.result;
    throw new Error(a.data.message);
  }
  async sms(r) {
    const t = `${this.baseUrl}/jeecg-boot/sys/sms/`, a = await J.post(t, r, this.getHeaders());
    if (a.data.success)
      return a.data.result;
    throw new Error(a.data.message);
  }
  async phoneLogin(r) {
    const t = `${this.baseUrl}/jeecg-boot/sys/phoneLogin/`, a = await J.post(t, r, this.getHeaders());
    if (a.data.success)
      return a.data.result;
    throw new Error(a.data.message);
  }
  async keepAlive() {
    const r = `${this.baseUrl}/jeecg-boot/sys/keepAlive/`, t = await J.get(r, this.getHeaders());
    if (t.data.success)
      return t.data.result;
    throw new Error(t.data.message);
  }
}
const fi = new ps();
class wl {
  constructor() {
    this._init = !1;
  }
  /**
   * 注册用户登录回调
   * 触发时机:
   * 1. 代码调用checkLogin,并且用户有效
   * @param callback
   */
  registerOnLoginCallback(r) {
    this._loginCallback = r;
  }
  /**
   * 注册用户登出回调
   * 触发时机:
   * 1. 用户token过期
   * 2. 用户切换
   * 3. 代码主动调用logout函数
   * @param callback
   */
  registeronLogoutCallback(r) {
    this._logoutCallback = r;
  }
  /**
   * 初始化配置
   * @param config
   */
  init(r) {
    if (!this._init)
      yo(r);
    else
      throw new Error("重复初始化");
  }
  /**
   * 判断用户是否登录
   * 建议这个函数只在初始化的时候调用一次就行了     *
   * @returns
   */
  async checkLogin() {
    const r = new v0();
    let t;
    const n = new URLSearchParams(location.href.split("?")[1]).get("token");
    if (n && (r.setUserInfoString(decodeURIComponent(n)), t = r.getUserInfo(), t && console.log("user from :>> ", "cookie")), !t && w0().supportFs && (console.log("是否是飞书进入应用: ", d0.openIn()), d0.openIn())) {
      await d0.init();
      const o = await d0.getUserInfo();
      if (o) {
        const { avatarUrl: u, name: f, userId: h, username: i, openId: s, unionId: b, token: l } = o;
        t = {
          user: {
            id: h,
            avatar: u,
            realname: f,
            username: i,
            openId: s,
            unionId: b
          },
          token: l
        }, r.setUserInfo(t), Z0(t), t && console.log("user from :>> ", "fs");
      }
    }
    if (t || (t = Ee(), t && console.log("user from :>> ", "Cache")), t)
      try {
        if (await fi.keepAlive(), this._loginCallback)
          try {
            this._loginCallback(t);
          } catch (f) {
            console.error(f);
          }
        if (this._checkUserLoginThread || (this._checkUserLoginThread = new mo(this)), r.setUserInfo(t), new URLSearchParams(window.location.href.split("?")[1]).get("token")) {
          let f = window.location.href.replace(/&?token=([0-9a-z]*)/, "");
          f = f.replace(/(\?|&)$/, ""), window.location.replace(f);
        }
        return t;
      } catch (o) {
        return console.log("ex :>> ", o), r.setUserInfo(), Promise.resolve(void 0);
      }
  }
  redirectToLogin() {
    const r = encodeURIComponent(window.location.href);
    return window.location.href = `${w0().loginUrl}?returnUrl=${r}`, Promise.resolve();
  }
  logout() {
    const r = Ee();
    if (Z0(void 0), new v0().setUserInfo(void 0), this._logoutCallback)
      try {
        this._logoutCallback(r);
      } catch (a) {
        console.error(a);
      }
    return Promise.resolve();
  }
  getUserInfo() {
    const r = Ee();
    return Promise.resolve(r);
  }
  getUserToken() {
    const r = Ee();
    return Promise.resolve(r == null ? void 0 : r.token);
  }
  getUserTokenSync() {
    const r = Ee();
    return r == null ? void 0 : r.token;
  }
  updateUserInfo(r) {
    Z0(r), new v0().setUserInfo(r);
  }
  openWithFs() {
    return d0.openIn();
  }
}
var gs = /* @__PURE__ */ ((e) => (e[e.Oss = 0] = "Oss", e[e.Minio = 1] = "Minio", e))(gs || {});
const bs = (e) => {
  Je().set("FileManagerConfig", e);
}, ci = () => Je().get("FileManagerConfig");
var li = { exports: {} }, zt = { exports: {} }, za;
function J0() {
  return za || (za = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function(a) {
        var n = t, o = n.lib, u = o.Base, f = o.WordArray, h = n.x64 = {};
        h.Word = u.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(i, s) {
            this.high = i, this.low = s;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), h.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(i, s) {
            i = this.words = i || [], s != a ? this.sigBytes = s : this.sigBytes = i.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var i = this.words, s = i.length, b = [], l = 0; l < s; l++) {
              var c = i[l];
              b.push(c.high), b.push(c.low);
            }
            return f.create(b, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var i = u.clone.call(this), s = i.words = this.words.slice(0), b = s.length, l = 0; l < b; l++)
              s[l] = s[l].clone();
            return i;
          }
        });
      }(), t;
    });
  }(zt)), zt.exports;
}
var Ht = { exports: {} }, Ha;
function ws() {
  return Ha || (Ha = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var a = t, n = a.lib, o = n.WordArray, u = o.init, f = o.init = function(h) {
            if (h instanceof ArrayBuffer && (h = new Uint8Array(h)), (h instanceof Int8Array || typeof Uint8ClampedArray < "u" && h instanceof Uint8ClampedArray || h instanceof Int16Array || h instanceof Uint16Array || h instanceof Int32Array || h instanceof Uint32Array || h instanceof Float32Array || h instanceof Float64Array) && (h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength)), h instanceof Uint8Array) {
              for (var i = h.byteLength, s = [], b = 0; b < i; b++)
                s[b >>> 2] |= h[b] << 24 - b % 4 * 8;
              u.call(this, s, i);
            } else
              u.apply(this, arguments);
          };
          f.prototype = o;
        }
      }(), t.lib.WordArray;
    });
  }(Ht)), Ht.exports;
}
var Ut = { exports: {} }, Ua;
function ys() {
  return Ua || (Ua = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = a.enc;
        u.Utf16 = u.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(h) {
            for (var i = h.words, s = h.sigBytes, b = [], l = 0; l < s; l += 2) {
              var c = i[l >>> 2] >>> 16 - l % 4 * 8 & 65535;
              b.push(String.fromCharCode(c));
            }
            return b.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(h) {
            for (var i = h.length, s = [], b = 0; b < i; b++)
              s[b >>> 1] |= h.charCodeAt(b) << 16 - b % 2 * 16;
            return o.create(s, i * 2);
          }
        }, u.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(h) {
            for (var i = h.words, s = h.sigBytes, b = [], l = 0; l < s; l += 2) {
              var c = f(i[l >>> 2] >>> 16 - l % 4 * 8 & 65535);
              b.push(String.fromCharCode(c));
            }
            return b.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(h) {
            for (var i = h.length, s = [], b = 0; b < i; b++)
              s[b >>> 1] |= f(h.charCodeAt(b) << 16 - b % 2 * 16);
            return o.create(s, i * 2);
          }
        };
        function f(h) {
          return h << 8 & 4278255360 | h >>> 8 & 16711935;
        }
      }(), t.enc.Utf16;
    });
  }(Ut)), Ut.exports;
}
var Dt = { exports: {} }, Da;
function ms() {
  return Da || (Da = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = a.enc;
        u.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(h, i = !0) {
            var s = h.words, b = h.sigBytes, l = i ? this._safe_map : this._map;
            h.clamp();
            for (var c = [], d = 0; d < b; d += 3)
              for (var _ = s[d >>> 2] >>> 24 - d % 4 * 8 & 255, g = s[d + 1 >>> 2] >>> 24 - (d + 1) % 4 * 8 & 255, y = s[d + 2 >>> 2] >>> 24 - (d + 2) % 4 * 8 & 255, v = _ << 16 | g << 8 | y, p = 0; p < 4 && d + p * 0.75 < b; p++)
                c.push(l.charAt(v >>> 6 * (3 - p) & 63));
            var x = l.charAt(64);
            if (x)
              for (; c.length % 4; )
                c.push(x);
            return c.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(h, i = !0) {
            var s = h.length, b = i ? this._safe_map : this._map, l = this._reverseMap;
            if (!l) {
              l = this._reverseMap = [];
              for (var c = 0; c < b.length; c++)
                l[b.charCodeAt(c)] = c;
            }
            var d = b.charAt(64);
            if (d) {
              var _ = h.indexOf(d);
              _ !== -1 && (s = _);
            }
            return f(h, s, l);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function f(h, i, s) {
          for (var b = [], l = 0, c = 0; c < i; c++)
            if (c % 4) {
              var d = s[h.charCodeAt(c - 1)] << c % 4 * 2, _ = s[h.charCodeAt(c)] >>> 6 - c % 4 * 2, g = d | _;
              b[l >>> 2] |= g << 24 - l % 4 * 8, l++;
            }
          return o.create(b, l);
        }
      }(), t.enc.Base64url;
    });
  }(Dt)), Dt.exports;
}
var Tt = { exports: {} }, Ta;
function ui() {
  return Ta || (Ta = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      return function(a) {
        var n = t, o = n.lib, u = o.WordArray, f = o.Hasher, h = n.algo, i = [], s = [];
        (function() {
          function c(y) {
            for (var v = a.sqrt(y), p = 2; p <= v; p++)
              if (!(y % p))
                return !1;
            return !0;
          }
          function d(y) {
            return (y - (y | 0)) * 4294967296 | 0;
          }
          for (var _ = 2, g = 0; g < 64; )
            c(_) && (g < 8 && (i[g] = d(a.pow(_, 1 / 2))), s[g] = d(a.pow(_, 1 / 3)), g++), _++;
        })();
        var b = [], l = h.SHA256 = f.extend({
          _doReset: function() {
            this._hash = new u.init(i.slice(0));
          },
          _doProcessBlock: function(c, d) {
            for (var _ = this._hash.words, g = _[0], y = _[1], v = _[2], p = _[3], x = _[4], S = _[5], E = _[6], k = _[7], C = 0; C < 64; C++) {
              if (C < 16)
                b[C] = c[d + C] | 0;
              else {
                var A = b[C - 15], w = (A << 25 | A >>> 7) ^ (A << 14 | A >>> 18) ^ A >>> 3, m = b[C - 2], B = (m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10;
                b[C] = w + b[C - 7] + B + b[C - 16];
              }
              var z = x & S ^ ~x & E, T = g & y ^ g & v ^ y & v, O = (g << 30 | g >>> 2) ^ (g << 19 | g >>> 13) ^ (g << 10 | g >>> 22), L = (x << 26 | x >>> 6) ^ (x << 21 | x >>> 11) ^ (x << 7 | x >>> 25), K = k + L + z + s[C] + b[C], $ = O + T;
              k = E, E = S, S = x, x = p + K | 0, p = v, v = y, y = g, g = K + $ | 0;
            }
            _[0] = _[0] + g | 0, _[1] = _[1] + y | 0, _[2] = _[2] + v | 0, _[3] = _[3] + p | 0, _[4] = _[4] + x | 0, _[5] = _[5] + S | 0, _[6] = _[6] + E | 0, _[7] = _[7] + k | 0;
          },
          _doFinalize: function() {
            var c = this._data, d = c.words, _ = this._nDataBytes * 8, g = c.sigBytes * 8;
            return d[g >>> 5] |= 128 << 24 - g % 32, d[(g + 64 >>> 9 << 4) + 14] = a.floor(_ / 4294967296), d[(g + 64 >>> 9 << 4) + 15] = _, c.sigBytes = d.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var c = f.clone.call(this);
            return c._hash = this._hash.clone(), c;
          }
        });
        n.SHA256 = f._createHelper(l), n.HmacSHA256 = f._createHmacHelper(l);
      }(Math), t.SHA256;
    });
  }(Tt)), Tt.exports;
}
var Ot = { exports: {} }, Oa;
function ks() {
  return Oa || (Oa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), ui());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = a.algo, f = u.SHA256, h = u.SHA224 = f.extend({
          _doReset: function() {
            this._hash = new o.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var i = f._doFinalize.call(this);
            return i.sigBytes -= 4, i;
          }
        });
        a.SHA224 = f._createHelper(h), a.HmacSHA224 = f._createHmacHelper(h);
      }(), t.SHA224;
    });
  }(Ot)), Ot.exports;
}
var It = { exports: {} }, Ia;
function di() {
  return Ia || (Ia = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), J0());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.Hasher, u = a.x64, f = u.Word, h = u.WordArray, i = a.algo;
        function s() {
          return f.create.apply(f, arguments);
        }
        var b = [
          s(1116352408, 3609767458),
          s(1899447441, 602891725),
          s(3049323471, 3964484399),
          s(3921009573, 2173295548),
          s(961987163, 4081628472),
          s(1508970993, 3053834265),
          s(2453635748, 2937671579),
          s(2870763221, 3664609560),
          s(3624381080, 2734883394),
          s(310598401, 1164996542),
          s(607225278, 1323610764),
          s(1426881987, 3590304994),
          s(1925078388, 4068182383),
          s(2162078206, 991336113),
          s(2614888103, 633803317),
          s(3248222580, 3479774868),
          s(3835390401, 2666613458),
          s(4022224774, 944711139),
          s(264347078, 2341262773),
          s(604807628, 2007800933),
          s(770255983, 1495990901),
          s(1249150122, 1856431235),
          s(1555081692, 3175218132),
          s(1996064986, 2198950837),
          s(2554220882, 3999719339),
          s(2821834349, 766784016),
          s(2952996808, 2566594879),
          s(3210313671, 3203337956),
          s(3336571891, 1034457026),
          s(3584528711, 2466948901),
          s(113926993, 3758326383),
          s(338241895, 168717936),
          s(666307205, 1188179964),
          s(773529912, 1546045734),
          s(1294757372, 1522805485),
          s(1396182291, 2643833823),
          s(1695183700, 2343527390),
          s(1986661051, 1014477480),
          s(2177026350, 1206759142),
          s(2456956037, 344077627),
          s(2730485921, 1290863460),
          s(2820302411, 3158454273),
          s(3259730800, 3505952657),
          s(3345764771, 106217008),
          s(3516065817, 3606008344),
          s(3600352804, 1432725776),
          s(4094571909, 1467031594),
          s(275423344, 851169720),
          s(430227734, 3100823752),
          s(506948616, 1363258195),
          s(659060556, 3750685593),
          s(883997877, 3785050280),
          s(958139571, 3318307427),
          s(1322822218, 3812723403),
          s(1537002063, 2003034995),
          s(1747873779, 3602036899),
          s(1955562222, 1575990012),
          s(2024104815, 1125592928),
          s(2227730452, 2716904306),
          s(2361852424, 442776044),
          s(2428436474, 593698344),
          s(2756734187, 3733110249),
          s(3204031479, 2999351573),
          s(3329325298, 3815920427),
          s(3391569614, 3928383900),
          s(3515267271, 566280711),
          s(3940187606, 3454069534),
          s(4118630271, 4000239992),
          s(116418474, 1914138554),
          s(174292421, 2731055270),
          s(289380356, 3203993006),
          s(460393269, 320620315),
          s(685471733, 587496836),
          s(852142971, 1086792851),
          s(1017036298, 365543100),
          s(1126000580, 2618297676),
          s(1288033470, 3409855158),
          s(1501505948, 4234509866),
          s(1607167915, 987167468),
          s(1816402316, 1246189591)
        ], l = [];
        (function() {
          for (var d = 0; d < 80; d++)
            l[d] = s();
        })();
        var c = i.SHA512 = o.extend({
          _doReset: function() {
            this._hash = new h.init([
              new f.init(1779033703, 4089235720),
              new f.init(3144134277, 2227873595),
              new f.init(1013904242, 4271175723),
              new f.init(2773480762, 1595750129),
              new f.init(1359893119, 2917565137),
              new f.init(2600822924, 725511199),
              new f.init(528734635, 4215389547),
              new f.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(d, _) {
            for (var g = this._hash.words, y = g[0], v = g[1], p = g[2], x = g[3], S = g[4], E = g[5], k = g[6], C = g[7], A = y.high, w = y.low, m = v.high, B = v.low, z = p.high, T = p.low, O = x.high, L = x.low, K = S.high, $ = S.low, M = E.high, Z = E.low, R = k.high, U = k.low, D = C.high, H = C.low, j = A, W = w, te = m, F = B, n0 = z, $e = T, nt = O, i0 = L, de = K, ne = $, T0 = M, o0 = Z, O0 = R, s0 = U, it = D, f0 = H, xe = 0; xe < 80; xe++) {
              var ce, me, I0 = l[xe];
              if (xe < 16)
                me = I0.high = d[_ + xe * 2] | 0, ce = I0.low = d[_ + xe * 2 + 1] | 0;
              else {
                var Pr = l[xe - 15], Ze = Pr.high, c0 = Pr.low, Xi = (Ze >>> 1 | c0 << 31) ^ (Ze >>> 8 | c0 << 24) ^ Ze >>> 7, Nr = (c0 >>> 1 | Ze << 31) ^ (c0 >>> 8 | Ze << 24) ^ (c0 >>> 7 | Ze << 25), qr = l[xe - 2], Me = qr.high, l0 = qr.low, Gi = (Me >>> 19 | l0 << 13) ^ (Me << 3 | l0 >>> 29) ^ Me >>> 6, $r = (l0 >>> 19 | Me << 13) ^ (l0 << 3 | Me >>> 29) ^ (l0 >>> 6 | Me << 26), Zr = l[xe - 7], Yi = Zr.high, Qi = Zr.low, Mr = l[xe - 16], Vi = Mr.high, Wr = Mr.low;
                ce = Nr + Qi, me = Xi + Yi + (ce >>> 0 < Nr >>> 0 ? 1 : 0), ce = ce + $r, me = me + Gi + (ce >>> 0 < $r >>> 0 ? 1 : 0), ce = ce + Wr, me = me + Vi + (ce >>> 0 < Wr >>> 0 ? 1 : 0), I0.high = me, I0.low = ce;
              }
              var Ji = de & T0 ^ ~de & O0, Kr = ne & o0 ^ ~ne & s0, eo = j & te ^ j & n0 ^ te & n0, to = W & F ^ W & $e ^ F & $e, ro = (j >>> 28 | W << 4) ^ (j << 30 | W >>> 2) ^ (j << 25 | W >>> 7), jr = (W >>> 28 | j << 4) ^ (W << 30 | j >>> 2) ^ (W << 25 | j >>> 7), ao = (de >>> 14 | ne << 18) ^ (de >>> 18 | ne << 14) ^ (de << 23 | ne >>> 9), no = (ne >>> 14 | de << 18) ^ (ne >>> 18 | de << 14) ^ (ne << 23 | de >>> 9), Xr = b[xe], io = Xr.high, Gr = Xr.low, ie = f0 + no, ke = it + ao + (ie >>> 0 < f0 >>> 0 ? 1 : 0), ie = ie + Kr, ke = ke + Ji + (ie >>> 0 < Kr >>> 0 ? 1 : 0), ie = ie + Gr, ke = ke + io + (ie >>> 0 < Gr >>> 0 ? 1 : 0), ie = ie + ce, ke = ke + me + (ie >>> 0 < ce >>> 0 ? 1 : 0), Yr = jr + to, oo = ro + eo + (Yr >>> 0 < jr >>> 0 ? 1 : 0);
              it = O0, f0 = s0, O0 = T0, s0 = o0, T0 = de, o0 = ne, ne = i0 + ie | 0, de = nt + ke + (ne >>> 0 < i0 >>> 0 ? 1 : 0) | 0, nt = n0, i0 = $e, n0 = te, $e = F, te = j, F = W, W = ie + Yr | 0, j = ke + oo + (W >>> 0 < ie >>> 0 ? 1 : 0) | 0;
            }
            w = y.low = w + W, y.high = A + j + (w >>> 0 < W >>> 0 ? 1 : 0), B = v.low = B + F, v.high = m + te + (B >>> 0 < F >>> 0 ? 1 : 0), T = p.low = T + $e, p.high = z + n0 + (T >>> 0 < $e >>> 0 ? 1 : 0), L = x.low = L + i0, x.high = O + nt + (L >>> 0 < i0 >>> 0 ? 1 : 0), $ = S.low = $ + ne, S.high = K + de + ($ >>> 0 < ne >>> 0 ? 1 : 0), Z = E.low = Z + o0, E.high = M + T0 + (Z >>> 0 < o0 >>> 0 ? 1 : 0), U = k.low = U + s0, k.high = R + O0 + (U >>> 0 < s0 >>> 0 ? 1 : 0), H = C.low = H + f0, C.high = D + it + (H >>> 0 < f0 >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var d = this._data, _ = d.words, g = this._nDataBytes * 8, y = d.sigBytes * 8;
            _[y >>> 5] |= 128 << 24 - y % 32, _[(y + 128 >>> 10 << 5) + 30] = Math.floor(g / 4294967296), _[(y + 128 >>> 10 << 5) + 31] = g, d.sigBytes = _.length * 4, this._process();
            var v = this._hash.toX32();
            return v;
          },
          clone: function() {
            var d = o.clone.call(this);
            return d._hash = this._hash.clone(), d;
          },
          blockSize: 1024 / 32
        });
        a.SHA512 = o._createHelper(c), a.HmacSHA512 = o._createHmacHelper(c);
      }(), t.SHA512;
    });
  }(It)), It.exports;
}
var Ft = { exports: {} }, Fa;
function Ss() {
  return Fa || (Fa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), J0(), di());
    })(I, function(t) {
      return function() {
        var a = t, n = a.x64, o = n.Word, u = n.WordArray, f = a.algo, h = f.SHA512, i = f.SHA384 = h.extend({
          _doReset: function() {
            this._hash = new u.init([
              new o.init(3418070365, 3238371032),
              new o.init(1654270250, 914150663),
              new o.init(2438529370, 812702999),
              new o.init(355462360, 4144912697),
              new o.init(1731405415, 4290775857),
              new o.init(2394180231, 1750603025),
              new o.init(3675008525, 1694076839),
              new o.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var s = h._doFinalize.call(this);
            return s.sigBytes -= 16, s;
          }
        });
        a.SHA384 = h._createHelper(i), a.HmacSHA384 = h._createHmacHelper(i);
      }(), t.SHA384;
    });
  }(Ft)), Ft.exports;
}
var Lt = { exports: {} }, La;
function Es() {
  return La || (La = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), J0());
    })(I, function(t) {
      return function(a) {
        var n = t, o = n.lib, u = o.WordArray, f = o.Hasher, h = n.x64, i = h.Word, s = n.algo, b = [], l = [], c = [];
        (function() {
          for (var g = 1, y = 0, v = 0; v < 24; v++) {
            b[g + 5 * y] = (v + 1) * (v + 2) / 2 % 64;
            var p = y % 5, x = (2 * g + 3 * y) % 5;
            g = p, y = x;
          }
          for (var g = 0; g < 5; g++)
            for (var y = 0; y < 5; y++)
              l[g + 5 * y] = y + (2 * g + 3 * y) % 5 * 5;
          for (var S = 1, E = 0; E < 24; E++) {
            for (var k = 0, C = 0, A = 0; A < 7; A++) {
              if (S & 1) {
                var w = (1 << A) - 1;
                w < 32 ? C ^= 1 << w : k ^= 1 << w - 32;
              }
              S & 128 ? S = S << 1 ^ 113 : S <<= 1;
            }
            c[E] = i.create(k, C);
          }
        })();
        var d = [];
        (function() {
          for (var g = 0; g < 25; g++)
            d[g] = i.create();
        })();
        var _ = s.SHA3 = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: f.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var g = this._state = [], y = 0; y < 25; y++)
              g[y] = new i.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(g, y) {
            for (var v = this._state, p = this.blockSize / 2, x = 0; x < p; x++) {
              var S = g[y + 2 * x], E = g[y + 2 * x + 1];
              S = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, E = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360;
              var k = v[x];
              k.high ^= E, k.low ^= S;
            }
            for (var C = 0; C < 24; C++) {
              for (var A = 0; A < 5; A++) {
                for (var w = 0, m = 0, B = 0; B < 5; B++) {
                  var k = v[A + 5 * B];
                  w ^= k.high, m ^= k.low;
                }
                var z = d[A];
                z.high = w, z.low = m;
              }
              for (var A = 0; A < 5; A++)
                for (var T = d[(A + 4) % 5], O = d[(A + 1) % 5], L = O.high, K = O.low, w = T.high ^ (L << 1 | K >>> 31), m = T.low ^ (K << 1 | L >>> 31), B = 0; B < 5; B++) {
                  var k = v[A + 5 * B];
                  k.high ^= w, k.low ^= m;
                }
              for (var $ = 1; $ < 25; $++) {
                var w, m, k = v[$], M = k.high, Z = k.low, R = b[$];
                R < 32 ? (w = M << R | Z >>> 32 - R, m = Z << R | M >>> 32 - R) : (w = Z << R - 32 | M >>> 64 - R, m = M << R - 32 | Z >>> 64 - R);
                var U = d[l[$]];
                U.high = w, U.low = m;
              }
              var D = d[0], H = v[0];
              D.high = H.high, D.low = H.low;
              for (var A = 0; A < 5; A++)
                for (var B = 0; B < 5; B++) {
                  var $ = A + 5 * B, k = v[$], j = d[$], W = d[(A + 1) % 5 + 5 * B], te = d[(A + 2) % 5 + 5 * B];
                  k.high = j.high ^ ~W.high & te.high, k.low = j.low ^ ~W.low & te.low;
                }
              var k = v[0], F = c[C];
              k.high ^= F.high, k.low ^= F.low;
            }
          },
          _doFinalize: function() {
            var g = this._data, y = g.words;
            this._nDataBytes * 8;
            var v = g.sigBytes * 8, p = this.blockSize * 32;
            y[v >>> 5] |= 1 << 24 - v % 32, y[(a.ceil((v + 1) / p) * p >>> 5) - 1] |= 128, g.sigBytes = y.length * 4, this._process();
            for (var x = this._state, S = this.cfg.outputLength / 8, E = S / 8, k = [], C = 0; C < E; C++) {
              var A = x[C], w = A.high, m = A.low;
              w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, m = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, k.push(m), k.push(w);
            }
            return new u.init(k, S);
          },
          clone: function() {
            for (var g = f.clone.call(this), y = g._state = this._state.slice(0), v = 0; v < 25; v++)
              y[v] = y[v].clone();
            return g;
          }
        });
        n.SHA3 = f._createHelper(_), n.HmacSHA3 = f._createHmacHelper(_);
      }(Math), t.SHA3;
    });
  }(Lt)), Lt.exports;
}
var Pt = { exports: {} }, Pa;
function Cs() {
  return Pa || (Pa = 1, function(e, r) {
    (function(t, a) {
      e.exports = a(P());
    })(I, function(t) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(a) {
        var n = t, o = n.lib, u = o.WordArray, f = o.Hasher, h = n.algo, i = u.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), s = u.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), b = u.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), l = u.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), c = u.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), d = u.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), _ = h.RIPEMD160 = f.extend({
          _doReset: function() {
            this._hash = u.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(E, k) {
            for (var C = 0; C < 16; C++) {
              var A = k + C, w = E[A];
              E[A] = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360;
            }
            var m = this._hash.words, B = c.words, z = d.words, T = i.words, O = s.words, L = b.words, K = l.words, $, M, Z, R, U, D, H, j, W, te;
            D = $ = m[0], H = M = m[1], j = Z = m[2], W = R = m[3], te = U = m[4];
            for (var F, C = 0; C < 80; C += 1)
              F = $ + E[k + T[C]] | 0, C < 16 ? F += g(M, Z, R) + B[0] : C < 32 ? F += y(M, Z, R) + B[1] : C < 48 ? F += v(M, Z, R) + B[2] : C < 64 ? F += p(M, Z, R) + B[3] : F += x(M, Z, R) + B[4], F = F | 0, F = S(F, L[C]), F = F + U | 0, $ = U, U = R, R = S(Z, 10), Z = M, M = F, F = D + E[k + O[C]] | 0, C < 16 ? F += x(H, j, W) + z[0] : C < 32 ? F += p(H, j, W) + z[1] : C < 48 ? F += v(H, j, W) + z[2] : C < 64 ? F += y(H, j, W) + z[3] : F += g(H, j, W) + z[4], F = F | 0, F = S(F, K[C]), F = F + te | 0, D = te, te = W, W = S(j, 10), j = H, H = F;
            F = m[1] + Z + W | 0, m[1] = m[2] + R + te | 0, m[2] = m[3] + U + D | 0, m[3] = m[4] + $ + H | 0, m[4] = m[0] + M + j | 0, m[0] = F;
          },
          _doFinalize: function() {
            var E = this._data, k = E.words, C = this._nDataBytes * 8, A = E.sigBytes * 8;
            k[A >>> 5] |= 128 << 24 - A % 32, k[(A + 64 >>> 9 << 4) + 14] = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, E.sigBytes = (k.length + 1) * 4, this._process();
            for (var w = this._hash, m = w.words, B = 0; B < 5; B++) {
              var z = m[B];
              m[B] = (z << 8 | z >>> 24) & 16711935 | (z << 24 | z >>> 8) & 4278255360;
            }
            return w;
          },
          clone: function() {
            var E = f.clone.call(this);
            return E._hash = this._hash.clone(), E;
          }
        });
        function g(E, k, C) {
          return E ^ k ^ C;
        }
        function y(E, k, C) {
          return E & k | ~E & C;
        }
        function v(E, k, C) {
          return (E | ~k) ^ C;
        }
        function p(E, k, C) {
          return E & C | k & ~C;
        }
        function x(E, k, C) {
          return E ^ (k | ~C);
        }
        function S(E, k) {
          return E << k | E >>> 32 - k;
        }
        n.RIPEMD160 = f._createHelper(_), n.HmacRIPEMD160 = f._createHmacHelper(_);
      }(), t.RIPEMD160;
    });
  }(Pt)), Pt.exports;
}
var Nt = { exports: {} }, Na;
function As() {
  return Na || (Na = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Ar(), Br());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.Base, u = n.WordArray, f = a.algo, h = f.SHA1, i = f.HMAC, s = f.PBKDF2 = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA1
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: o.extend({
            keySize: 128 / 32,
            hasher: h,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(b) {
            this.cfg = this.cfg.extend(b);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(b, l) {
            for (var c = this.cfg, d = i.create(c.hasher, b), _ = u.create(), g = u.create([1]), y = _.words, v = g.words, p = c.keySize, x = c.iterations; y.length < p; ) {
              var S = d.update(l).finalize(g);
              d.reset();
              for (var E = S.words, k = E.length, C = S, A = 1; A < x; A++) {
                C = d.finalize(C), d.reset();
                for (var w = C.words, m = 0; m < k; m++)
                  E[m] ^= w[m];
              }
              _.concat(S), v[0]++;
            }
            return _.sigBytes = p * 4, _;
          }
        });
        a.PBKDF2 = function(b, l, c) {
          return s.create(c).compute(b, l);
        };
      }(), t.PBKDF2;
    });
  }(Nt)), Nt.exports;
}
var qt = { exports: {} }, qa;
function Bs() {
  return qa || (qa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.mode.CFB = function() {
        var a = t.lib.BlockCipherMode.extend();
        a.Encryptor = a.extend({
          processBlock: function(o, u) {
            var f = this._cipher, h = f.blockSize;
            n.call(this, o, u, h, f), this._prevBlock = o.slice(u, u + h);
          }
        }), a.Decryptor = a.extend({
          processBlock: function(o, u) {
            var f = this._cipher, h = f.blockSize, i = o.slice(u, u + h);
            n.call(this, o, u, h, f), this._prevBlock = i;
          }
        });
        function n(o, u, f, h) {
          var i, s = this._iv;
          s ? (i = s.slice(0), this._iv = void 0) : i = this._prevBlock, h.encryptBlock(i, 0);
          for (var b = 0; b < f; b++)
            o[u + b] ^= i[b];
        }
        return a;
      }(), t.mode.CFB;
    });
  }(qt)), qt.exports;
}
var $t = { exports: {} }, $a;
function Rs() {
  return $a || ($a = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.mode.CTR = function() {
        var a = t.lib.BlockCipherMode.extend(), n = a.Encryptor = a.extend({
          processBlock: function(o, u) {
            var f = this._cipher, h = f.blockSize, i = this._iv, s = this._counter;
            i && (s = this._counter = i.slice(0), this._iv = void 0);
            var b = s.slice(0);
            f.encryptBlock(b, 0), s[h - 1] = s[h - 1] + 1 | 0;
            for (var l = 0; l < h; l++)
              o[u + l] ^= b[l];
          }
        });
        return a.Decryptor = n, a;
      }(), t.mode.CTR;
    });
  }($t)), $t.exports;
}
var Zt = { exports: {} }, Za;
function zs() {
  return Za || (Za = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return t.mode.CTRGladman = function() {
        var a = t.lib.BlockCipherMode.extend();
        function n(f) {
          if ((f >> 24 & 255) === 255) {
            var h = f >> 16 & 255, i = f >> 8 & 255, s = f & 255;
            h === 255 ? (h = 0, i === 255 ? (i = 0, s === 255 ? s = 0 : ++s) : ++i) : ++h, f = 0, f += h << 16, f += i << 8, f += s;
          } else
            f += 1 << 24;
          return f;
        }
        function o(f) {
          return (f[0] = n(f[0])) === 0 && (f[1] = n(f[1])), f;
        }
        var u = a.Encryptor = a.extend({
          processBlock: function(f, h) {
            var i = this._cipher, s = i.blockSize, b = this._iv, l = this._counter;
            b && (l = this._counter = b.slice(0), this._iv = void 0), o(l);
            var c = l.slice(0);
            i.encryptBlock(c, 0);
            for (var d = 0; d < s; d++)
              f[h + d] ^= c[d];
          }
        });
        return a.Decryptor = u, a;
      }(), t.mode.CTRGladman;
    });
  }(Zt)), Zt.exports;
}
var Mt = { exports: {} }, Ma;
function Hs() {
  return Ma || (Ma = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.mode.OFB = function() {
        var a = t.lib.BlockCipherMode.extend(), n = a.Encryptor = a.extend({
          processBlock: function(o, u) {
            var f = this._cipher, h = f.blockSize, i = this._iv, s = this._keystream;
            i && (s = this._keystream = i.slice(0), this._iv = void 0), f.encryptBlock(s, 0);
            for (var b = 0; b < h; b++)
              o[u + b] ^= s[b];
          }
        });
        return a.Decryptor = n, a;
      }(), t.mode.OFB;
    });
  }(Mt)), Mt.exports;
}
var Wt = { exports: {} }, Wa;
function Us() {
  return Wa || (Wa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.pad.AnsiX923 = {
        pad: function(a, n) {
          var o = a.sigBytes, u = n * 4, f = u - o % u, h = o + f - 1;
          a.clamp(), a.words[h >>> 2] |= f << 24 - h % 4 * 8, a.sigBytes += f;
        },
        unpad: function(a) {
          var n = a.words[a.sigBytes - 1 >>> 2] & 255;
          a.sigBytes -= n;
        }
      }, t.pad.Ansix923;
    });
  }(Wt)), Wt.exports;
}
var Kt = { exports: {} }, Ka;
function Ds() {
  return Ka || (Ka = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.pad.Iso10126 = {
        pad: function(a, n) {
          var o = n * 4, u = o - a.sigBytes % o;
          a.concat(t.lib.WordArray.random(u - 1)).concat(t.lib.WordArray.create([u << 24], 1));
        },
        unpad: function(a) {
          var n = a.words[a.sigBytes - 1 >>> 2] & 255;
          a.sigBytes -= n;
        }
      }, t.pad.Iso10126;
    });
  }(Kt)), Kt.exports;
}
var jt = { exports: {} }, ja;
function Ts() {
  return ja || (ja = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.pad.Iso97971 = {
        pad: function(a, n) {
          a.concat(t.lib.WordArray.create([2147483648], 1)), t.pad.ZeroPadding.pad(a, n);
        },
        unpad: function(a) {
          t.pad.ZeroPadding.unpad(a), a.sigBytes--;
        }
      }, t.pad.Iso97971;
    });
  }(jt)), jt.exports;
}
var Xt = { exports: {} }, Xa;
function Os() {
  return Xa || (Xa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.pad.ZeroPadding = {
        pad: function(a, n) {
          var o = n * 4;
          a.clamp(), a.sigBytes += o - (a.sigBytes % o || o);
        },
        unpad: function(a) {
          for (var n = a.words, o = a.sigBytes - 1, o = a.sigBytes - 1; o >= 0; o--)
            if (n[o >>> 2] >>> 24 - o % 4 * 8 & 255) {
              a.sigBytes = o + 1;
              break;
            }
        }
      }, t.pad.ZeroPadding;
    });
  }(Xt)), Xt.exports;
}
var Gt = { exports: {} }, Ga;
function Is() {
  return Ga || (Ga = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return t.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, t.pad.NoPadding;
    });
  }(Gt)), Gt.exports;
}
var Yt = { exports: {} }, Ya;
function Fs() {
  return Ya || (Ya = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Y());
    })(I, function(t) {
      return function(a) {
        var n = t, o = n.lib, u = o.CipherParams, f = n.enc, h = f.Hex, i = n.format;
        i.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(s) {
            return s.ciphertext.toString(h);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(s) {
            var b = h.parse(s);
            return u.create({ ciphertext: b });
          }
        };
      }(), t.format.Hex;
    });
  }(Yt)), Yt.exports;
}
var Qt = { exports: {} }, Qa;
function Ls() {
  return Qa || (Qa = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Le(), e0(), Pe(), Y());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.WordArray, u = n.BlockCipher, f = a.algo, h = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], i = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], s = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], b = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], l = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], c = f.DES = u.extend({
          _doReset: function() {
            for (var y = this._key, v = y.words, p = [], x = 0; x < 56; x++) {
              var S = h[x] - 1;
              p[x] = v[S >>> 5] >>> 31 - S % 32 & 1;
            }
            for (var E = this._subKeys = [], k = 0; k < 16; k++) {
              for (var C = E[k] = [], A = s[k], x = 0; x < 24; x++)
                C[x / 6 | 0] |= p[(i[x] - 1 + A) % 28] << 31 - x % 6, C[4 + (x / 6 | 0)] |= p[28 + (i[x + 24] - 1 + A) % 28] << 31 - x % 6;
              C[0] = C[0] << 1 | C[0] >>> 31;
              for (var x = 1; x < 7; x++)
                C[x] = C[x] >>> (x - 1) * 4 + 3;
              C[7] = C[7] << 5 | C[7] >>> 27;
            }
            for (var w = this._invSubKeys = [], x = 0; x < 16; x++)
              w[x] = E[15 - x];
          },
          encryptBlock: function(y, v) {
            this._doCryptBlock(y, v, this._subKeys);
          },
          decryptBlock: function(y, v) {
            this._doCryptBlock(y, v, this._invSubKeys);
          },
          _doCryptBlock: function(y, v, p) {
            this._lBlock = y[v], this._rBlock = y[v + 1], d.call(this, 4, 252645135), d.call(this, 16, 65535), _.call(this, 2, 858993459), _.call(this, 8, 16711935), d.call(this, 1, 1431655765);
            for (var x = 0; x < 16; x++) {
              for (var S = p[x], E = this._lBlock, k = this._rBlock, C = 0, A = 0; A < 8; A++)
                C |= b[A][((k ^ S[A]) & l[A]) >>> 0];
              this._lBlock = k, this._rBlock = E ^ C;
            }
            var w = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = w, d.call(this, 1, 1431655765), _.call(this, 8, 16711935), _.call(this, 2, 858993459), d.call(this, 16, 65535), d.call(this, 4, 252645135), y[v] = this._lBlock, y[v + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function d(y, v) {
          var p = (this._lBlock >>> y ^ this._rBlock) & v;
          this._rBlock ^= p, this._lBlock ^= p << y;
        }
        function _(y, v) {
          var p = (this._rBlock >>> y ^ this._lBlock) & v;
          this._lBlock ^= p, this._rBlock ^= p << y;
        }
        a.DES = u._createHelper(c);
        var g = f.TripleDES = u.extend({
          _doReset: function() {
            var y = this._key, v = y.words;
            if (v.length !== 2 && v.length !== 4 && v.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var p = v.slice(0, 2), x = v.length < 4 ? v.slice(0, 2) : v.slice(2, 4), S = v.length < 6 ? v.slice(0, 2) : v.slice(4, 6);
            this._des1 = c.createEncryptor(o.create(p)), this._des2 = c.createEncryptor(o.create(x)), this._des3 = c.createEncryptor(o.create(S));
          },
          encryptBlock: function(y, v) {
            this._des1.encryptBlock(y, v), this._des2.decryptBlock(y, v), this._des3.encryptBlock(y, v);
          },
          decryptBlock: function(y, v) {
            this._des3.decryptBlock(y, v), this._des2.encryptBlock(y, v), this._des1.decryptBlock(y, v);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        a.TripleDES = u._createHelper(g);
      }(), t.TripleDES;
    });
  }(Qt)), Qt.exports;
}
var Vt = { exports: {} }, Va;
function Ps() {
  return Va || (Va = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Le(), e0(), Pe(), Y());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.StreamCipher, u = a.algo, f = u.RC4 = o.extend({
          _doReset: function() {
            for (var s = this._key, b = s.words, l = s.sigBytes, c = this._S = [], d = 0; d < 256; d++)
              c[d] = d;
            for (var d = 0, _ = 0; d < 256; d++) {
              var g = d % l, y = b[g >>> 2] >>> 24 - g % 4 * 8 & 255;
              _ = (_ + c[d] + y) % 256;
              var v = c[d];
              c[d] = c[_], c[_] = v;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(s, b) {
            s[b] ^= h.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function h() {
          for (var s = this._S, b = this._i, l = this._j, c = 0, d = 0; d < 4; d++) {
            b = (b + 1) % 256, l = (l + s[b]) % 256;
            var _ = s[b];
            s[b] = s[l], s[l] = _, c |= s[(s[b] + s[l]) % 256] << 24 - d * 8;
          }
          return this._i = b, this._j = l, c;
        }
        a.RC4 = o._createHelper(f);
        var i = u.RC4Drop = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: f.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            f._doReset.call(this);
            for (var s = this.cfg.drop; s > 0; s--)
              h.call(this);
          }
        });
        a.RC4Drop = o._createHelper(i);
      }(), t.RC4;
    });
  }(Vt)), Vt.exports;
}
var Jt = { exports: {} }, Ja;
function Ns() {
  return Ja || (Ja = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Le(), e0(), Pe(), Y());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.StreamCipher, u = a.algo, f = [], h = [], i = [], s = u.Rabbit = o.extend({
          _doReset: function() {
            for (var l = this._key.words, c = this.cfg.iv, d = 0; d < 4; d++)
              l[d] = (l[d] << 8 | l[d] >>> 24) & 16711935 | (l[d] << 24 | l[d] >>> 8) & 4278255360;
            var _ = this._X = [
              l[0],
              l[3] << 16 | l[2] >>> 16,
              l[1],
              l[0] << 16 | l[3] >>> 16,
              l[2],
              l[1] << 16 | l[0] >>> 16,
              l[3],
              l[2] << 16 | l[1] >>> 16
            ], g = this._C = [
              l[2] << 16 | l[2] >>> 16,
              l[0] & 4294901760 | l[1] & 65535,
              l[3] << 16 | l[3] >>> 16,
              l[1] & 4294901760 | l[2] & 65535,
              l[0] << 16 | l[0] >>> 16,
              l[2] & 4294901760 | l[3] & 65535,
              l[1] << 16 | l[1] >>> 16,
              l[3] & 4294901760 | l[0] & 65535
            ];
            this._b = 0;
            for (var d = 0; d < 4; d++)
              b.call(this);
            for (var d = 0; d < 8; d++)
              g[d] ^= _[d + 4 & 7];
            if (c) {
              var y = c.words, v = y[0], p = y[1], x = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, S = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360, E = x >>> 16 | S & 4294901760, k = S << 16 | x & 65535;
              g[0] ^= x, g[1] ^= E, g[2] ^= S, g[3] ^= k, g[4] ^= x, g[5] ^= E, g[6] ^= S, g[7] ^= k;
              for (var d = 0; d < 4; d++)
                b.call(this);
            }
          },
          _doProcessBlock: function(l, c) {
            var d = this._X;
            b.call(this), f[0] = d[0] ^ d[5] >>> 16 ^ d[3] << 16, f[1] = d[2] ^ d[7] >>> 16 ^ d[5] << 16, f[2] = d[4] ^ d[1] >>> 16 ^ d[7] << 16, f[3] = d[6] ^ d[3] >>> 16 ^ d[1] << 16;
            for (var _ = 0; _ < 4; _++)
              f[_] = (f[_] << 8 | f[_] >>> 24) & 16711935 | (f[_] << 24 | f[_] >>> 8) & 4278255360, l[c + _] ^= f[_];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function b() {
          for (var l = this._X, c = this._C, d = 0; d < 8; d++)
            h[d] = c[d];
          c[0] = c[0] + 1295307597 + this._b | 0, c[1] = c[1] + 3545052371 + (c[0] >>> 0 < h[0] >>> 0 ? 1 : 0) | 0, c[2] = c[2] + 886263092 + (c[1] >>> 0 < h[1] >>> 0 ? 1 : 0) | 0, c[3] = c[3] + 1295307597 + (c[2] >>> 0 < h[2] >>> 0 ? 1 : 0) | 0, c[4] = c[4] + 3545052371 + (c[3] >>> 0 < h[3] >>> 0 ? 1 : 0) | 0, c[5] = c[5] + 886263092 + (c[4] >>> 0 < h[4] >>> 0 ? 1 : 0) | 0, c[6] = c[6] + 1295307597 + (c[5] >>> 0 < h[5] >>> 0 ? 1 : 0) | 0, c[7] = c[7] + 3545052371 + (c[6] >>> 0 < h[6] >>> 0 ? 1 : 0) | 0, this._b = c[7] >>> 0 < h[7] >>> 0 ? 1 : 0;
          for (var d = 0; d < 8; d++) {
            var _ = l[d] + c[d], g = _ & 65535, y = _ >>> 16, v = ((g * g >>> 17) + g * y >>> 15) + y * y, p = ((_ & 4294901760) * _ | 0) + ((_ & 65535) * _ | 0);
            i[d] = v ^ p;
          }
          l[0] = i[0] + (i[7] << 16 | i[7] >>> 16) + (i[6] << 16 | i[6] >>> 16) | 0, l[1] = i[1] + (i[0] << 8 | i[0] >>> 24) + i[7] | 0, l[2] = i[2] + (i[1] << 16 | i[1] >>> 16) + (i[0] << 16 | i[0] >>> 16) | 0, l[3] = i[3] + (i[2] << 8 | i[2] >>> 24) + i[1] | 0, l[4] = i[4] + (i[3] << 16 | i[3] >>> 16) + (i[2] << 16 | i[2] >>> 16) | 0, l[5] = i[5] + (i[4] << 8 | i[4] >>> 24) + i[3] | 0, l[6] = i[6] + (i[5] << 16 | i[5] >>> 16) + (i[4] << 16 | i[4] >>> 16) | 0, l[7] = i[7] + (i[6] << 8 | i[6] >>> 24) + i[5] | 0;
        }
        a.Rabbit = o._createHelper(s);
      }(), t.Rabbit;
    });
  }(Jt)), Jt.exports;
}
var er = { exports: {} }, en;
function qs() {
  return en || (en = 1, function(e, r) {
    (function(t, a, n) {
      e.exports = a(P(), Le(), e0(), Pe(), Y());
    })(I, function(t) {
      return function() {
        var a = t, n = a.lib, o = n.StreamCipher, u = a.algo, f = [], h = [], i = [], s = u.RabbitLegacy = o.extend({
          _doReset: function() {
            var l = this._key.words, c = this.cfg.iv, d = this._X = [
              l[0],
              l[3] << 16 | l[2] >>> 16,
              l[1],
              l[0] << 16 | l[3] >>> 16,
              l[2],
              l[1] << 16 | l[0] >>> 16,
              l[3],
              l[2] << 16 | l[1] >>> 16
            ], _ = this._C = [
              l[2] << 16 | l[2] >>> 16,
              l[0] & 4294901760 | l[1] & 65535,
              l[3] << 16 | l[3] >>> 16,
              l[1] & 4294901760 | l[2] & 65535,
              l[0] << 16 | l[0] >>> 16,
              l[2] & 4294901760 | l[3] & 65535,
              l[1] << 16 | l[1] >>> 16,
              l[3] & 4294901760 | l[0] & 65535
            ];
            this._b = 0;
            for (var g = 0; g < 4; g++)
              b.call(this);
            for (var g = 0; g < 8; g++)
              _[g] ^= d[g + 4 & 7];
            if (c) {
              var y = c.words, v = y[0], p = y[1], x = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, S = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360, E = x >>> 16 | S & 4294901760, k = S << 16 | x & 65535;
              _[0] ^= x, _[1] ^= E, _[2] ^= S, _[3] ^= k, _[4] ^= x, _[5] ^= E, _[6] ^= S, _[7] ^= k;
              for (var g = 0; g < 4; g++)
                b.call(this);
            }
          },
          _doProcessBlock: function(l, c) {
            var d = this._X;
            b.call(this), f[0] = d[0] ^ d[5] >>> 16 ^ d[3] << 16, f[1] = d[2] ^ d[7] >>> 16 ^ d[5] << 16, f[2] = d[4] ^ d[1] >>> 16 ^ d[7] << 16, f[3] = d[6] ^ d[3] >>> 16 ^ d[1] << 16;
            for (var _ = 0; _ < 4; _++)
              f[_] = (f[_] << 8 | f[_] >>> 24) & 16711935 | (f[_] << 24 | f[_] >>> 8) & 4278255360, l[c + _] ^= f[_];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function b() {
          for (var l = this._X, c = this._C, d = 0; d < 8; d++)
            h[d] = c[d];
          c[0] = c[0] + 1295307597 + this._b | 0, c[1] = c[1] + 3545052371 + (c[0] >>> 0 < h[0] >>> 0 ? 1 : 0) | 0, c[2] = c[2] + 886263092 + (c[1] >>> 0 < h[1] >>> 0 ? 1 : 0) | 0, c[3] = c[3] + 1295307597 + (c[2] >>> 0 < h[2] >>> 0 ? 1 : 0) | 0, c[4] = c[4] + 3545052371 + (c[3] >>> 0 < h[3] >>> 0 ? 1 : 0) | 0, c[5] = c[5] + 886263092 + (c[4] >>> 0 < h[4] >>> 0 ? 1 : 0) | 0, c[6] = c[6] + 1295307597 + (c[5] >>> 0 < h[5] >>> 0 ? 1 : 0) | 0, c[7] = c[7] + 3545052371 + (c[6] >>> 0 < h[6] >>> 0 ? 1 : 0) | 0, this._b = c[7] >>> 0 < h[7] >>> 0 ? 1 : 0;
          for (var d = 0; d < 8; d++) {
            var _ = l[d] + c[d], g = _ & 65535, y = _ >>> 16, v = ((g * g >>> 17) + g * y >>> 15) + y * y, p = ((_ & 4294901760) * _ | 0) + ((_ & 65535) * _ | 0);
            i[d] = v ^ p;
          }
          l[0] = i[0] + (i[7] << 16 | i[7] >>> 16) + (i[6] << 16 | i[6] >>> 16) | 0, l[1] = i[1] + (i[0] << 8 | i[0] >>> 24) + i[7] | 0, l[2] = i[2] + (i[1] << 16 | i[1] >>> 16) + (i[0] << 16 | i[0] >>> 16) | 0, l[3] = i[3] + (i[2] << 8 | i[2] >>> 24) + i[1] | 0, l[4] = i[4] + (i[3] << 16 | i[3] >>> 16) + (i[2] << 16 | i[2] >>> 16) | 0, l[5] = i[5] + (i[4] << 8 | i[4] >>> 24) + i[3] | 0, l[6] = i[6] + (i[5] << 16 | i[5] >>> 16) + (i[4] << 16 | i[4] >>> 16) | 0, l[7] = i[7] + (i[6] << 8 | i[6] >>> 24) + i[5] | 0;
        }
        a.RabbitLegacy = o._createHelper(s);
      }(), t.RabbitLegacy;
    });
  }(er)), er.exports;
}
(function(e, r) {
  (function(t, a, n) {
    e.exports = a(P(), J0(), ws(), ys(), Le(), ms(), e0(), Ar(), ui(), ks(), di(), Ss(), Es(), Cs(), Br(), As(), Pe(), Y(), Bs(), Rs(), zs(), Hs(), Gn, Us(), Ds(), Ts(), Os(), Is(), Fs(), Wn, Ls(), Ps(), Ns(), qs());
  })(I, function(t) {
    return t;
  });
})(li);
var $s = li.exports;
const tn = /* @__PURE__ */ Ue($s);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const Zs = 4, rn = 0, an = 1, Ms = 2;
function t0(e) {
  let r = e.length;
  for (; --r >= 0; )
    e[r] = 0;
}
const Ws = 0, xi = 1, Ks = 2, js = 3, Xs = 258, Ur = 29, z0 = 256, y0 = z0 + 1 + Ur, Ge = 30, Dr = 19, hi = 2 * y0 + 1, De = 15, tr = 16, Gs = 7, Tr = 256, _i = 16, vi = 17, pi = 18, gr = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), K0 = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), Ys = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), gi = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Qs = 512, we = new Array((y0 + 2) * 2);
t0(we);
const p0 = new Array(Ge * 2);
t0(p0);
const m0 = new Array(Qs);
t0(m0);
const k0 = new Array(Xs - js + 1);
t0(k0);
const Or = new Array(Ur);
t0(Or);
const j0 = new Array(Ge);
t0(j0);
function rr(e, r, t, a, n) {
  this.static_tree = e, this.extra_bits = r, this.extra_base = t, this.elems = a, this.max_length = n, this.has_stree = e && e.length;
}
let bi, wi, yi;
function ar(e, r) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = r;
}
const mi = (e) => e < 256 ? m0[e] : m0[256 + (e >>> 7)], S0 = (e, r) => {
  e.pending_buf[e.pending++] = r & 255, e.pending_buf[e.pending++] = r >>> 8 & 255;
}, ae = (e, r, t) => {
  e.bi_valid > tr - t ? (e.bi_buf |= r << e.bi_valid & 65535, S0(e, e.bi_buf), e.bi_buf = r >> tr - e.bi_valid, e.bi_valid += t - tr) : (e.bi_buf |= r << e.bi_valid & 65535, e.bi_valid += t);
}, ve = (e, r, t) => {
  ae(
    e,
    t[r * 2],
    t[r * 2 + 1]
    /*.Len*/
  );
}, ki = (e, r) => {
  let t = 0;
  do
    t |= e & 1, e >>>= 1, t <<= 1;
  while (--r > 0);
  return t >>> 1;
}, Vs = (e) => {
  e.bi_valid === 16 ? (S0(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, Js = (e, r) => {
  const t = r.dyn_tree, a = r.max_code, n = r.stat_desc.static_tree, o = r.stat_desc.has_stree, u = r.stat_desc.extra_bits, f = r.stat_desc.extra_base, h = r.stat_desc.max_length;
  let i, s, b, l, c, d, _ = 0;
  for (l = 0; l <= De; l++)
    e.bl_count[l] = 0;
  for (t[e.heap[e.heap_max] * 2 + 1] = 0, i = e.heap_max + 1; i < hi; i++)
    s = e.heap[i], l = t[t[s * 2 + 1] * 2 + 1] + 1, l > h && (l = h, _++), t[s * 2 + 1] = l, !(s > a) && (e.bl_count[l]++, c = 0, s >= f && (c = u[s - f]), d = t[s * 2], e.opt_len += d * (l + c), o && (e.static_len += d * (n[s * 2 + 1] + c)));
  if (_ !== 0) {
    do {
      for (l = h - 1; e.bl_count[l] === 0; )
        l--;
      e.bl_count[l]--, e.bl_count[l + 1] += 2, e.bl_count[h]--, _ -= 2;
    } while (_ > 0);
    for (l = h; l !== 0; l--)
      for (s = e.bl_count[l]; s !== 0; )
        b = e.heap[--i], !(b > a) && (t[b * 2 + 1] !== l && (e.opt_len += (l - t[b * 2 + 1]) * t[b * 2], t[b * 2 + 1] = l), s--);
  }
}, Si = (e, r, t) => {
  const a = new Array(De + 1);
  let n = 0, o, u;
  for (o = 1; o <= De; o++)
    n = n + t[o - 1] << 1, a[o] = n;
  for (u = 0; u <= r; u++) {
    let f = e[u * 2 + 1];
    f !== 0 && (e[u * 2] = ki(a[f]++, f));
  }
}, ef = () => {
  let e, r, t, a, n;
  const o = new Array(De + 1);
  for (t = 0, a = 0; a < Ur - 1; a++)
    for (Or[a] = t, e = 0; e < 1 << gr[a]; e++)
      k0[t++] = a;
  for (k0[t - 1] = a, n = 0, a = 0; a < 16; a++)
    for (j0[a] = n, e = 0; e < 1 << K0[a]; e++)
      m0[n++] = a;
  for (n >>= 7; a < Ge; a++)
    for (j0[a] = n << 7, e = 0; e < 1 << K0[a] - 7; e++)
      m0[256 + n++] = a;
  for (r = 0; r <= De; r++)
    o[r] = 0;
  for (e = 0; e <= 143; )
    we[e * 2 + 1] = 8, e++, o[8]++;
  for (; e <= 255; )
    we[e * 2 + 1] = 9, e++, o[9]++;
  for (; e <= 279; )
    we[e * 2 + 1] = 7, e++, o[7]++;
  for (; e <= 287; )
    we[e * 2 + 1] = 8, e++, o[8]++;
  for (Si(we, y0 + 1, o), e = 0; e < Ge; e++)
    p0[e * 2 + 1] = 5, p0[e * 2] = ki(e, 5);
  bi = new rr(we, gr, z0 + 1, y0, De), wi = new rr(p0, K0, 0, Ge, De), yi = new rr(new Array(0), Ys, 0, Dr, Gs);
}, Ei = (e) => {
  let r;
  for (r = 0; r < y0; r++)
    e.dyn_ltree[r * 2] = 0;
  for (r = 0; r < Ge; r++)
    e.dyn_dtree[r * 2] = 0;
  for (r = 0; r < Dr; r++)
    e.bl_tree[r * 2] = 0;
  e.dyn_ltree[Tr * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, Ci = (e) => {
  e.bi_valid > 8 ? S0(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, nn = (e, r, t, a) => {
  const n = r * 2, o = t * 2;
  return e[n] < e[o] || e[n] === e[o] && a[r] <= a[t];
}, nr = (e, r, t) => {
  const a = e.heap[t];
  let n = t << 1;
  for (; n <= e.heap_len && (n < e.heap_len && nn(r, e.heap[n + 1], e.heap[n], e.depth) && n++, !nn(r, a, e.heap[n], e.depth)); )
    e.heap[t] = e.heap[n], t = n, n <<= 1;
  e.heap[t] = a;
}, on = (e, r, t) => {
  let a, n, o = 0, u, f;
  if (e.sym_next !== 0)
    do
      a = e.pending_buf[e.sym_buf + o++] & 255, a += (e.pending_buf[e.sym_buf + o++] & 255) << 8, n = e.pending_buf[e.sym_buf + o++], a === 0 ? ve(e, n, r) : (u = k0[n], ve(e, u + z0 + 1, r), f = gr[u], f !== 0 && (n -= Or[u], ae(e, n, f)), a--, u = mi(a), ve(e, u, t), f = K0[u], f !== 0 && (a -= j0[u], ae(e, a, f)));
    while (o < e.sym_next);
  ve(e, Tr, r);
}, br = (e, r) => {
  const t = r.dyn_tree, a = r.stat_desc.static_tree, n = r.stat_desc.has_stree, o = r.stat_desc.elems;
  let u, f, h = -1, i;
  for (e.heap_len = 0, e.heap_max = hi, u = 0; u < o; u++)
    t[u * 2] !== 0 ? (e.heap[++e.heap_len] = h = u, e.depth[u] = 0) : t[u * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    i = e.heap[++e.heap_len] = h < 2 ? ++h : 0, t[i * 2] = 1, e.depth[i] = 0, e.opt_len--, n && (e.static_len -= a[i * 2 + 1]);
  for (r.max_code = h, u = e.heap_len >> 1; u >= 1; u--)
    nr(e, t, u);
  i = o;
  do
    u = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], nr(
      e,
      t,
      1
      /*SMALLEST*/
    ), f = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = u, e.heap[--e.heap_max] = f, t[i * 2] = t[u * 2] + t[f * 2], e.depth[i] = (e.depth[u] >= e.depth[f] ? e.depth[u] : e.depth[f]) + 1, t[u * 2 + 1] = t[f * 2 + 1] = i, e.heap[
      1
      /*SMALLEST*/
    ] = i++, nr(
      e,
      t,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], Js(e, r), Si(t, h, e.bl_count);
}, sn = (e, r, t) => {
  let a, n = -1, o, u = r[0 * 2 + 1], f = 0, h = 7, i = 4;
  for (u === 0 && (h = 138, i = 3), r[(t + 1) * 2 + 1] = 65535, a = 0; a <= t; a++)
    o = u, u = r[(a + 1) * 2 + 1], !(++f < h && o === u) && (f < i ? e.bl_tree[o * 2] += f : o !== 0 ? (o !== n && e.bl_tree[o * 2]++, e.bl_tree[_i * 2]++) : f <= 10 ? e.bl_tree[vi * 2]++ : e.bl_tree[pi * 2]++, f = 0, n = o, u === 0 ? (h = 138, i = 3) : o === u ? (h = 6, i = 3) : (h = 7, i = 4));
}, fn = (e, r, t) => {
  let a, n = -1, o, u = r[0 * 2 + 1], f = 0, h = 7, i = 4;
  for (u === 0 && (h = 138, i = 3), a = 0; a <= t; a++)
    if (o = u, u = r[(a + 1) * 2 + 1], !(++f < h && o === u)) {
      if (f < i)
        do
          ve(e, o, e.bl_tree);
        while (--f !== 0);
      else
        o !== 0 ? (o !== n && (ve(e, o, e.bl_tree), f--), ve(e, _i, e.bl_tree), ae(e, f - 3, 2)) : f <= 10 ? (ve(e, vi, e.bl_tree), ae(e, f - 3, 3)) : (ve(e, pi, e.bl_tree), ae(e, f - 11, 7));
      f = 0, n = o, u === 0 ? (h = 138, i = 3) : o === u ? (h = 6, i = 3) : (h = 7, i = 4);
    }
}, tf = (e) => {
  let r;
  for (sn(e, e.dyn_ltree, e.l_desc.max_code), sn(e, e.dyn_dtree, e.d_desc.max_code), br(e, e.bl_desc), r = Dr - 1; r >= 3 && e.bl_tree[gi[r] * 2 + 1] === 0; r--)
    ;
  return e.opt_len += 3 * (r + 1) + 5 + 5 + 4, r;
}, rf = (e, r, t, a) => {
  let n;
  for (ae(e, r - 257, 5), ae(e, t - 1, 5), ae(e, a - 4, 4), n = 0; n < a; n++)
    ae(e, e.bl_tree[gi[n] * 2 + 1], 3);
  fn(e, e.dyn_ltree, r - 1), fn(e, e.dyn_dtree, t - 1);
}, af = (e) => {
  let r = 4093624447, t;
  for (t = 0; t <= 31; t++, r >>>= 1)
    if (r & 1 && e.dyn_ltree[t * 2] !== 0)
      return rn;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return an;
  for (t = 32; t < z0; t++)
    if (e.dyn_ltree[t * 2] !== 0)
      return an;
  return rn;
};
let cn = !1;
const nf = (e) => {
  cn || (ef(), cn = !0), e.l_desc = new ar(e.dyn_ltree, bi), e.d_desc = new ar(e.dyn_dtree, wi), e.bl_desc = new ar(e.bl_tree, yi), e.bi_buf = 0, e.bi_valid = 0, Ei(e);
}, Ai = (e, r, t, a) => {
  ae(e, (Ws << 1) + (a ? 1 : 0), 3), Ci(e), S0(e, t), S0(e, ~t), t && e.pending_buf.set(e.window.subarray(r, r + t), e.pending), e.pending += t;
}, of = (e) => {
  ae(e, xi << 1, 3), ve(e, Tr, we), Vs(e);
}, sf = (e, r, t, a) => {
  let n, o, u = 0;
  e.level > 0 ? (e.strm.data_type === Ms && (e.strm.data_type = af(e)), br(e, e.l_desc), br(e, e.d_desc), u = tf(e), n = e.opt_len + 3 + 7 >>> 3, o = e.static_len + 3 + 7 >>> 3, o <= n && (n = o)) : n = o = t + 5, t + 4 <= n && r !== -1 ? Ai(e, r, t, a) : e.strategy === Zs || o === n ? (ae(e, (xi << 1) + (a ? 1 : 0), 3), on(e, we, p0)) : (ae(e, (Ks << 1) + (a ? 1 : 0), 3), rf(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, u + 1), on(e, e.dyn_ltree, e.dyn_dtree)), Ei(e), a && Ci(e);
}, ff = (e, r, t) => (e.pending_buf[e.sym_buf + e.sym_next++] = r, e.pending_buf[e.sym_buf + e.sym_next++] = r >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = t, r === 0 ? e.dyn_ltree[t * 2]++ : (e.matches++, r--, e.dyn_ltree[(k0[t] + z0 + 1) * 2]++, e.dyn_dtree[mi(r) * 2]++), e.sym_next === e.sym_end);
var cf = nf, lf = Ai, uf = sf, df = ff, xf = of, hf = {
  _tr_init: cf,
  _tr_stored_block: lf,
  _tr_flush_block: uf,
  _tr_tally: df,
  _tr_align: xf
};
const _f = (e, r, t, a) => {
  let n = e & 65535 | 0, o = e >>> 16 & 65535 | 0, u = 0;
  for (; t !== 0; ) {
    u = t > 2e3 ? 2e3 : t, t -= u;
    do
      n = n + r[a++] | 0, o = o + n | 0;
    while (--u);
    n %= 65521, o %= 65521;
  }
  return n | o << 16 | 0;
};
var E0 = _f;
const vf = () => {
  let e, r = [];
  for (var t = 0; t < 256; t++) {
    e = t;
    for (var a = 0; a < 8; a++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    r[t] = e;
  }
  return r;
}, pf = new Uint32Array(vf()), gf = (e, r, t, a) => {
  const n = pf, o = a + t;
  e ^= -1;
  for (let u = a; u < o; u++)
    e = e >>> 8 ^ n[(e ^ r[u]) & 255];
  return e ^ -1;
};
var G = gf, Ye = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, H0 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: bf, _tr_stored_block: wr, _tr_flush_block: wf, _tr_tally: Re, _tr_align: yf } = hf, {
  Z_NO_FLUSH: ze,
  Z_PARTIAL_FLUSH: mf,
  Z_FULL_FLUSH: kf,
  Z_FINISH: le,
  Z_BLOCK: ln,
  Z_OK: Q,
  Z_STREAM_END: un,
  Z_STREAM_ERROR: pe,
  Z_DATA_ERROR: Sf,
  Z_BUF_ERROR: ir,
  Z_DEFAULT_COMPRESSION: Ef,
  Z_FILTERED: Cf,
  Z_HUFFMAN_ONLY: L0,
  Z_RLE: Af,
  Z_FIXED: Bf,
  Z_DEFAULT_STRATEGY: Rf,
  Z_UNKNOWN: zf,
  Z_DEFLATED: et
} = H0, Hf = 9, Uf = 15, Df = 8, Tf = 29, Of = 256, yr = Of + 1 + Tf, If = 30, Ff = 19, Lf = 2 * yr + 1, Pf = 15, N = 3, Be = 258, ge = Be + N + 1, Nf = 32, Qe = 42, Ir = 57, mr = 69, kr = 73, Sr = 91, Er = 103, Te = 113, h0 = 666, ee = 1, r0 = 2, Ie = 3, a0 = 4, qf = 3, Oe = (e, r) => (e.msg = Ye[r], r), dn = (e) => e * 2 - (e > 4 ? 9 : 0), Ce = (e) => {
  let r = e.length;
  for (; --r >= 0; )
    e[r] = 0;
}, $f = (e) => {
  let r, t, a, n = e.w_size;
  r = e.hash_size, a = r;
  do
    t = e.head[--a], e.head[a] = t >= n ? t - n : 0;
  while (--r);
  r = n, a = r;
  do
    t = e.prev[--a], e.prev[a] = t >= n ? t - n : 0;
  while (--r);
};
let Zf = (e, r, t) => (r << e.hash_shift ^ t) & e.hash_mask, He = Zf;
const oe = (e) => {
  const r = e.state;
  let t = r.pending;
  t > e.avail_out && (t = e.avail_out), t !== 0 && (e.output.set(r.pending_buf.subarray(r.pending_out, r.pending_out + t), e.next_out), e.next_out += t, r.pending_out += t, e.total_out += t, e.avail_out -= t, r.pending -= t, r.pending === 0 && (r.pending_out = 0));
}, se = (e, r) => {
  wf(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, r), e.block_start = e.strstart, oe(e.strm);
}, q = (e, r) => {
  e.pending_buf[e.pending++] = r;
}, x0 = (e, r) => {
  e.pending_buf[e.pending++] = r >>> 8 & 255, e.pending_buf[e.pending++] = r & 255;
}, Cr = (e, r, t, a) => {
  let n = e.avail_in;
  return n > a && (n = a), n === 0 ? 0 : (e.avail_in -= n, r.set(e.input.subarray(e.next_in, e.next_in + n), t), e.state.wrap === 1 ? e.adler = E0(e.adler, r, n, t) : e.state.wrap === 2 && (e.adler = G(e.adler, r, n, t)), e.next_in += n, e.total_in += n, n);
}, Bi = (e, r) => {
  let t = e.max_chain_length, a = e.strstart, n, o, u = e.prev_length, f = e.nice_match;
  const h = e.strstart > e.w_size - ge ? e.strstart - (e.w_size - ge) : 0, i = e.window, s = e.w_mask, b = e.prev, l = e.strstart + Be;
  let c = i[a + u - 1], d = i[a + u];
  e.prev_length >= e.good_match && (t >>= 2), f > e.lookahead && (f = e.lookahead);
  do
    if (n = r, !(i[n + u] !== d || i[n + u - 1] !== c || i[n] !== i[a] || i[++n] !== i[a + 1])) {
      a += 2, n++;
      do
        ;
      while (i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && i[++a] === i[++n] && a < l);
      if (o = Be - (l - a), a = l - Be, o > u) {
        if (e.match_start = r, u = o, o >= f)
          break;
        c = i[a + u - 1], d = i[a + u];
      }
    }
  while ((r = b[r & s]) > h && --t !== 0);
  return u <= e.lookahead ? u : e.lookahead;
}, Ve = (e) => {
  const r = e.w_size;
  let t, a, n;
  do {
    if (a = e.window_size - e.lookahead - e.strstart, e.strstart >= r + (r - ge) && (e.window.set(e.window.subarray(r, r + r - a), 0), e.match_start -= r, e.strstart -= r, e.block_start -= r, e.insert > e.strstart && (e.insert = e.strstart), $f(e), a += r), e.strm.avail_in === 0)
      break;
    if (t = Cr(e.strm, e.window, e.strstart + e.lookahead, a), e.lookahead += t, e.lookahead + e.insert >= N)
      for (n = e.strstart - e.insert, e.ins_h = e.window[n], e.ins_h = He(e, e.ins_h, e.window[n + 1]); e.insert && (e.ins_h = He(e, e.ins_h, e.window[n + N - 1]), e.prev[n & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = n, n++, e.insert--, !(e.lookahead + e.insert < N)); )
        ;
  } while (e.lookahead < ge && e.strm.avail_in !== 0);
}, Ri = (e, r) => {
  let t = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, a, n, o, u = 0, f = e.strm.avail_in;
  do {
    if (a = 65535, o = e.bi_valid + 42 >> 3, e.strm.avail_out < o || (o = e.strm.avail_out - o, n = e.strstart - e.block_start, a > n + e.strm.avail_in && (a = n + e.strm.avail_in), a > o && (a = o), a < t && (a === 0 && r !== le || r === ze || a !== n + e.strm.avail_in)))
      break;
    u = r === le && a === n + e.strm.avail_in ? 1 : 0, wr(e, 0, 0, u), e.pending_buf[e.pending - 4] = a, e.pending_buf[e.pending - 3] = a >> 8, e.pending_buf[e.pending - 2] = ~a, e.pending_buf[e.pending - 1] = ~a >> 8, oe(e.strm), n && (n > a && (n = a), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + n), e.strm.next_out), e.strm.next_out += n, e.strm.avail_out -= n, e.strm.total_out += n, e.block_start += n, a -= n), a && (Cr(e.strm, e.strm.output, e.strm.next_out, a), e.strm.next_out += a, e.strm.avail_out -= a, e.strm.total_out += a);
  } while (u === 0);
  return f -= e.strm.avail_in, f && (f >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= f && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - f, e.strm.next_in), e.strstart), e.strstart += f, e.insert += f > e.w_size - e.insert ? e.w_size - e.insert : f), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), u ? a0 : r !== ze && r !== le && e.strm.avail_in === 0 && e.strstart === e.block_start ? r0 : (o = e.window_size - e.strstart, e.strm.avail_in > o && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, o += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), o > e.strm.avail_in && (o = e.strm.avail_in), o && (Cr(e.strm, e.window, e.strstart, o), e.strstart += o, e.insert += o > e.w_size - e.insert ? e.w_size - e.insert : o), e.high_water < e.strstart && (e.high_water = e.strstart), o = e.bi_valid + 42 >> 3, o = e.pending_buf_size - o > 65535 ? 65535 : e.pending_buf_size - o, t = o > e.w_size ? e.w_size : o, n = e.strstart - e.block_start, (n >= t || (n || r === le) && r !== ze && e.strm.avail_in === 0 && n <= o) && (a = n > o ? o : n, u = r === le && e.strm.avail_in === 0 && a === n ? 1 : 0, wr(e, e.block_start, a, u), e.block_start += a, oe(e.strm)), u ? Ie : ee);
}, or = (e, r) => {
  let t, a;
  for (; ; ) {
    if (e.lookahead < ge) {
      if (Ve(e), e.lookahead < ge && r === ze)
        return ee;
      if (e.lookahead === 0)
        break;
    }
    if (t = 0, e.lookahead >= N && (e.ins_h = He(e, e.ins_h, e.window[e.strstart + N - 1]), t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), t !== 0 && e.strstart - t <= e.w_size - ge && (e.match_length = Bi(e, t)), e.match_length >= N)
      if (a = Re(e, e.strstart - e.match_start, e.match_length - N), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= N) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = He(e, e.ins_h, e.window[e.strstart + N - 1]), t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = He(e, e.ins_h, e.window[e.strstart + 1]);
    else
      a = Re(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (a && (se(e, !1), e.strm.avail_out === 0))
      return ee;
  }
  return e.insert = e.strstart < N - 1 ? e.strstart : N - 1, r === le ? (se(e, !0), e.strm.avail_out === 0 ? Ie : a0) : e.sym_next && (se(e, !1), e.strm.avail_out === 0) ? ee : r0;
}, je = (e, r) => {
  let t, a, n;
  for (; ; ) {
    if (e.lookahead < ge) {
      if (Ve(e), e.lookahead < ge && r === ze)
        return ee;
      if (e.lookahead === 0)
        break;
    }
    if (t = 0, e.lookahead >= N && (e.ins_h = He(e, e.ins_h, e.window[e.strstart + N - 1]), t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = N - 1, t !== 0 && e.prev_length < e.max_lazy_match && e.strstart - t <= e.w_size - ge && (e.match_length = Bi(e, t), e.match_length <= 5 && (e.strategy === Cf || e.match_length === N && e.strstart - e.match_start > 4096) && (e.match_length = N - 1)), e.prev_length >= N && e.match_length <= e.prev_length) {
      n = e.strstart + e.lookahead - N, a = Re(e, e.strstart - 1 - e.prev_match, e.prev_length - N), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= n && (e.ins_h = He(e, e.ins_h, e.window[e.strstart + N - 1]), t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = N - 1, e.strstart++, a && (se(e, !1), e.strm.avail_out === 0))
        return ee;
    } else if (e.match_available) {
      if (a = Re(e, 0, e.window[e.strstart - 1]), a && se(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return ee;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (a = Re(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < N - 1 ? e.strstart : N - 1, r === le ? (se(e, !0), e.strm.avail_out === 0 ? Ie : a0) : e.sym_next && (se(e, !1), e.strm.avail_out === 0) ? ee : r0;
}, Mf = (e, r) => {
  let t, a, n, o;
  const u = e.window;
  for (; ; ) {
    if (e.lookahead <= Be) {
      if (Ve(e), e.lookahead <= Be && r === ze)
        return ee;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= N && e.strstart > 0 && (n = e.strstart - 1, a = u[n], a === u[++n] && a === u[++n] && a === u[++n])) {
      o = e.strstart + Be;
      do
        ;
      while (a === u[++n] && a === u[++n] && a === u[++n] && a === u[++n] && a === u[++n] && a === u[++n] && a === u[++n] && a === u[++n] && n < o);
      e.match_length = Be - (o - n), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= N ? (t = Re(e, 1, e.match_length - N), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (t = Re(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), t && (se(e, !1), e.strm.avail_out === 0))
      return ee;
  }
  return e.insert = 0, r === le ? (se(e, !0), e.strm.avail_out === 0 ? Ie : a0) : e.sym_next && (se(e, !1), e.strm.avail_out === 0) ? ee : r0;
}, Wf = (e, r) => {
  let t;
  for (; ; ) {
    if (e.lookahead === 0 && (Ve(e), e.lookahead === 0)) {
      if (r === ze)
        return ee;
      break;
    }
    if (e.match_length = 0, t = Re(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, t && (se(e, !1), e.strm.avail_out === 0))
      return ee;
  }
  return e.insert = 0, r === le ? (se(e, !0), e.strm.avail_out === 0 ? Ie : a0) : e.sym_next && (se(e, !1), e.strm.avail_out === 0) ? ee : r0;
};
function _e(e, r, t, a, n) {
  this.good_length = e, this.max_lazy = r, this.nice_length = t, this.max_chain = a, this.func = n;
}
const _0 = [
  /*      good lazy nice chain */
  new _e(0, 0, 0, 0, Ri),
  /* 0 store only */
  new _e(4, 4, 8, 4, or),
  /* 1 max speed, no lazy matches */
  new _e(4, 5, 16, 8, or),
  /* 2 */
  new _e(4, 6, 32, 32, or),
  /* 3 */
  new _e(4, 4, 16, 16, je),
  /* 4 lazy matches */
  new _e(8, 16, 32, 32, je),
  /* 5 */
  new _e(8, 16, 128, 128, je),
  /* 6 */
  new _e(8, 32, 128, 256, je),
  /* 7 */
  new _e(32, 128, 258, 1024, je),
  /* 8 */
  new _e(32, 258, 258, 4096, je)
  /* 9 max compression */
], Kf = (e) => {
  e.window_size = 2 * e.w_size, Ce(e.head), e.max_lazy_match = _0[e.level].max_lazy, e.good_match = _0[e.level].good_length, e.nice_match = _0[e.level].nice_length, e.max_chain_length = _0[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = N - 1, e.match_available = 0, e.ins_h = 0;
};
function jf() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = et, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(Lf * 2), this.dyn_dtree = new Uint16Array((2 * If + 1) * 2), this.bl_tree = new Uint16Array((2 * Ff + 1) * 2), Ce(this.dyn_ltree), Ce(this.dyn_dtree), Ce(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(Pf + 1), this.heap = new Uint16Array(2 * yr + 1), Ce(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * yr + 1), Ce(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const U0 = (e) => {
  if (!e)
    return 1;
  const r = e.state;
  return !r || r.strm !== e || r.status !== Qe && //#ifdef GZIP
  r.status !== Ir && //#endif
  r.status !== mr && r.status !== kr && r.status !== Sr && r.status !== Er && r.status !== Te && r.status !== h0 ? 1 : 0;
}, zi = (e) => {
  if (U0(e))
    return Oe(e, pe);
  e.total_in = e.total_out = 0, e.data_type = zf;
  const r = e.state;
  return r.pending = 0, r.pending_out = 0, r.wrap < 0 && (r.wrap = -r.wrap), r.status = //#ifdef GZIP
  r.wrap === 2 ? Ir : (
    //#endif
    r.wrap ? Qe : Te
  ), e.adler = r.wrap === 2 ? 0 : 1, r.last_flush = -2, bf(r), Q;
}, Hi = (e) => {
  const r = zi(e);
  return r === Q && Kf(e.state), r;
}, Xf = (e, r) => U0(e) || e.state.wrap !== 2 ? pe : (e.state.gzhead = r, Q), Ui = (e, r, t, a, n, o) => {
  if (!e)
    return pe;
  let u = 1;
  if (r === Ef && (r = 6), a < 0 ? (u = 0, a = -a) : a > 15 && (u = 2, a -= 16), n < 1 || n > Hf || t !== et || a < 8 || a > 15 || r < 0 || r > 9 || o < 0 || o > Bf || a === 8 && u !== 1)
    return Oe(e, pe);
  a === 8 && (a = 9);
  const f = new jf();
  return e.state = f, f.strm = e, f.status = Qe, f.wrap = u, f.gzhead = null, f.w_bits = a, f.w_size = 1 << f.w_bits, f.w_mask = f.w_size - 1, f.hash_bits = n + 7, f.hash_size = 1 << f.hash_bits, f.hash_mask = f.hash_size - 1, f.hash_shift = ~~((f.hash_bits + N - 1) / N), f.window = new Uint8Array(f.w_size * 2), f.head = new Uint16Array(f.hash_size), f.prev = new Uint16Array(f.w_size), f.lit_bufsize = 1 << n + 6, f.pending_buf_size = f.lit_bufsize * 4, f.pending_buf = new Uint8Array(f.pending_buf_size), f.sym_buf = f.lit_bufsize, f.sym_end = (f.lit_bufsize - 1) * 3, f.level = r, f.strategy = o, f.method = t, Hi(e);
}, Gf = (e, r) => Ui(e, r, et, Uf, Df, Rf), Yf = (e, r) => {
  if (U0(e) || r > ln || r < 0)
    return e ? Oe(e, pe) : pe;
  const t = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || t.status === h0 && r !== le)
    return Oe(e, e.avail_out === 0 ? ir : pe);
  const a = t.last_flush;
  if (t.last_flush = r, t.pending !== 0) {
    if (oe(e), e.avail_out === 0)
      return t.last_flush = -1, Q;
  } else if (e.avail_in === 0 && dn(r) <= dn(a) && r !== le)
    return Oe(e, ir);
  if (t.status === h0 && e.avail_in !== 0)
    return Oe(e, ir);
  if (t.status === Qe && t.wrap === 0 && (t.status = Te), t.status === Qe) {
    let n = et + (t.w_bits - 8 << 4) << 8, o = -1;
    if (t.strategy >= L0 || t.level < 2 ? o = 0 : t.level < 6 ? o = 1 : t.level === 6 ? o = 2 : o = 3, n |= o << 6, t.strstart !== 0 && (n |= Nf), n += 31 - n % 31, x0(t, n), t.strstart !== 0 && (x0(t, e.adler >>> 16), x0(t, e.adler & 65535)), e.adler = 1, t.status = Te, oe(e), t.pending !== 0)
      return t.last_flush = -1, Q;
  }
  if (t.status === Ir) {
    if (e.adler = 0, q(t, 31), q(t, 139), q(t, 8), t.gzhead)
      q(
        t,
        (t.gzhead.text ? 1 : 0) + (t.gzhead.hcrc ? 2 : 0) + (t.gzhead.extra ? 4 : 0) + (t.gzhead.name ? 8 : 0) + (t.gzhead.comment ? 16 : 0)
      ), q(t, t.gzhead.time & 255), q(t, t.gzhead.time >> 8 & 255), q(t, t.gzhead.time >> 16 & 255), q(t, t.gzhead.time >> 24 & 255), q(t, t.level === 9 ? 2 : t.strategy >= L0 || t.level < 2 ? 4 : 0), q(t, t.gzhead.os & 255), t.gzhead.extra && t.gzhead.extra.length && (q(t, t.gzhead.extra.length & 255), q(t, t.gzhead.extra.length >> 8 & 255)), t.gzhead.hcrc && (e.adler = G(e.adler, t.pending_buf, t.pending, 0)), t.gzindex = 0, t.status = mr;
    else if (q(t, 0), q(t, 0), q(t, 0), q(t, 0), q(t, 0), q(t, t.level === 9 ? 2 : t.strategy >= L0 || t.level < 2 ? 4 : 0), q(t, qf), t.status = Te, oe(e), t.pending !== 0)
      return t.last_flush = -1, Q;
  }
  if (t.status === mr) {
    if (t.gzhead.extra) {
      let n = t.pending, o = (t.gzhead.extra.length & 65535) - t.gzindex;
      for (; t.pending + o > t.pending_buf_size; ) {
        let f = t.pending_buf_size - t.pending;
        if (t.pending_buf.set(t.gzhead.extra.subarray(t.gzindex, t.gzindex + f), t.pending), t.pending = t.pending_buf_size, t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n)), t.gzindex += f, oe(e), t.pending !== 0)
          return t.last_flush = -1, Q;
        n = 0, o -= f;
      }
      let u = new Uint8Array(t.gzhead.extra);
      t.pending_buf.set(u.subarray(t.gzindex, t.gzindex + o), t.pending), t.pending += o, t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n)), t.gzindex = 0;
    }
    t.status = kr;
  }
  if (t.status === kr) {
    if (t.gzhead.name) {
      let n = t.pending, o;
      do {
        if (t.pending === t.pending_buf_size) {
          if (t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n)), oe(e), t.pending !== 0)
            return t.last_flush = -1, Q;
          n = 0;
        }
        t.gzindex < t.gzhead.name.length ? o = t.gzhead.name.charCodeAt(t.gzindex++) & 255 : o = 0, q(t, o);
      } while (o !== 0);
      t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n)), t.gzindex = 0;
    }
    t.status = Sr;
  }
  if (t.status === Sr) {
    if (t.gzhead.comment) {
      let n = t.pending, o;
      do {
        if (t.pending === t.pending_buf_size) {
          if (t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n)), oe(e), t.pending !== 0)
            return t.last_flush = -1, Q;
          n = 0;
        }
        t.gzindex < t.gzhead.comment.length ? o = t.gzhead.comment.charCodeAt(t.gzindex++) & 255 : o = 0, q(t, o);
      } while (o !== 0);
      t.gzhead.hcrc && t.pending > n && (e.adler = G(e.adler, t.pending_buf, t.pending - n, n));
    }
    t.status = Er;
  }
  if (t.status === Er) {
    if (t.gzhead.hcrc) {
      if (t.pending + 2 > t.pending_buf_size && (oe(e), t.pending !== 0))
        return t.last_flush = -1, Q;
      q(t, e.adler & 255), q(t, e.adler >> 8 & 255), e.adler = 0;
    }
    if (t.status = Te, oe(e), t.pending !== 0)
      return t.last_flush = -1, Q;
  }
  if (e.avail_in !== 0 || t.lookahead !== 0 || r !== ze && t.status !== h0) {
    let n = t.level === 0 ? Ri(t, r) : t.strategy === L0 ? Wf(t, r) : t.strategy === Af ? Mf(t, r) : _0[t.level].func(t, r);
    if ((n === Ie || n === a0) && (t.status = h0), n === ee || n === Ie)
      return e.avail_out === 0 && (t.last_flush = -1), Q;
    if (n === r0 && (r === mf ? yf(t) : r !== ln && (wr(t, 0, 0, !1), r === kf && (Ce(t.head), t.lookahead === 0 && (t.strstart = 0, t.block_start = 0, t.insert = 0))), oe(e), e.avail_out === 0))
      return t.last_flush = -1, Q;
  }
  return r !== le ? Q : t.wrap <= 0 ? un : (t.wrap === 2 ? (q(t, e.adler & 255), q(t, e.adler >> 8 & 255), q(t, e.adler >> 16 & 255), q(t, e.adler >> 24 & 255), q(t, e.total_in & 255), q(t, e.total_in >> 8 & 255), q(t, e.total_in >> 16 & 255), q(t, e.total_in >> 24 & 255)) : (x0(t, e.adler >>> 16), x0(t, e.adler & 65535)), oe(e), t.wrap > 0 && (t.wrap = -t.wrap), t.pending !== 0 ? Q : un);
}, Qf = (e) => {
  if (U0(e))
    return pe;
  const r = e.state.status;
  return e.state = null, r === Te ? Oe(e, Sf) : Q;
}, Vf = (e, r) => {
  let t = r.length;
  if (U0(e))
    return pe;
  const a = e.state, n = a.wrap;
  if (n === 2 || n === 1 && a.status !== Qe || a.lookahead)
    return pe;
  if (n === 1 && (e.adler = E0(e.adler, r, t, 0)), a.wrap = 0, t >= a.w_size) {
    n === 0 && (Ce(a.head), a.strstart = 0, a.block_start = 0, a.insert = 0);
    let h = new Uint8Array(a.w_size);
    h.set(r.subarray(t - a.w_size, t), 0), r = h, t = a.w_size;
  }
  const o = e.avail_in, u = e.next_in, f = e.input;
  for (e.avail_in = t, e.next_in = 0, e.input = r, Ve(a); a.lookahead >= N; ) {
    let h = a.strstart, i = a.lookahead - (N - 1);
    do
      a.ins_h = He(a, a.ins_h, a.window[h + N - 1]), a.prev[h & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = h, h++;
    while (--i);
    a.strstart = h, a.lookahead = N - 1, Ve(a);
  }
  return a.strstart += a.lookahead, a.block_start = a.strstart, a.insert = a.lookahead, a.lookahead = 0, a.match_length = a.prev_length = N - 1, a.match_available = 0, e.next_in = u, e.input = f, e.avail_in = o, a.wrap = n, Q;
};
var Jf = Gf, ec = Ui, tc = Hi, rc = zi, ac = Xf, nc = Yf, ic = Qf, oc = Vf, sc = "pako deflate (from Nodeca project)", g0 = {
  deflateInit: Jf,
  deflateInit2: ec,
  deflateReset: tc,
  deflateResetKeep: rc,
  deflateSetHeader: ac,
  deflate: nc,
  deflateEnd: ic,
  deflateSetDictionary: oc,
  deflateInfo: sc
};
const fc = (e, r) => Object.prototype.hasOwnProperty.call(e, r);
var cc = function(e) {
  const r = Array.prototype.slice.call(arguments, 1);
  for (; r.length; ) {
    const t = r.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const a in t)
        fc(t, a) && (e[a] = t[a]);
    }
  }
  return e;
}, lc = (e) => {
  let r = 0;
  for (let a = 0, n = e.length; a < n; a++)
    r += e[a].length;
  const t = new Uint8Array(r);
  for (let a = 0, n = 0, o = e.length; a < o; a++) {
    let u = e[a];
    t.set(u, n), n += u.length;
  }
  return t;
}, rt = {
  assign: cc,
  flattenChunks: lc
};
let Di = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  Di = !1;
}
const C0 = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  C0[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
C0[254] = C0[254] = 1;
var uc = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let r, t, a, n, o, u = e.length, f = 0;
  for (n = 0; n < u; n++)
    t = e.charCodeAt(n), (t & 64512) === 55296 && n + 1 < u && (a = e.charCodeAt(n + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), n++)), f += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (r = new Uint8Array(f), o = 0, n = 0; o < f; n++)
    t = e.charCodeAt(n), (t & 64512) === 55296 && n + 1 < u && (a = e.charCodeAt(n + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), n++)), t < 128 ? r[o++] = t : t < 2048 ? (r[o++] = 192 | t >>> 6, r[o++] = 128 | t & 63) : t < 65536 ? (r[o++] = 224 | t >>> 12, r[o++] = 128 | t >>> 6 & 63, r[o++] = 128 | t & 63) : (r[o++] = 240 | t >>> 18, r[o++] = 128 | t >>> 12 & 63, r[o++] = 128 | t >>> 6 & 63, r[o++] = 128 | t & 63);
  return r;
};
const dc = (e, r) => {
  if (r < 65534 && e.subarray && Di)
    return String.fromCharCode.apply(null, e.length === r ? e : e.subarray(0, r));
  let t = "";
  for (let a = 0; a < r; a++)
    t += String.fromCharCode(e[a]);
  return t;
};
var xc = (e, r) => {
  const t = r || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, r));
  let a, n;
  const o = new Array(t * 2);
  for (n = 0, a = 0; a < t; ) {
    let u = e[a++];
    if (u < 128) {
      o[n++] = u;
      continue;
    }
    let f = C0[u];
    if (f > 4) {
      o[n++] = 65533, a += f - 1;
      continue;
    }
    for (u &= f === 2 ? 31 : f === 3 ? 15 : 7; f > 1 && a < t; )
      u = u << 6 | e[a++] & 63, f--;
    if (f > 1) {
      o[n++] = 65533;
      continue;
    }
    u < 65536 ? o[n++] = u : (u -= 65536, o[n++] = 55296 | u >> 10 & 1023, o[n++] = 56320 | u & 1023);
  }
  return dc(o, n);
}, hc = (e, r) => {
  r = r || e.length, r > e.length && (r = e.length);
  let t = r - 1;
  for (; t >= 0 && (e[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? r : t + C0[e[t]] > r ? t : r;
}, A0 = {
  string2buf: uc,
  buf2string: xc,
  utf8border: hc
};
function _c() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var Ti = _c;
const Oi = Object.prototype.toString, {
  Z_NO_FLUSH: vc,
  Z_SYNC_FLUSH: pc,
  Z_FULL_FLUSH: gc,
  Z_FINISH: bc,
  Z_OK: X0,
  Z_STREAM_END: wc,
  Z_DEFAULT_COMPRESSION: yc,
  Z_DEFAULT_STRATEGY: mc,
  Z_DEFLATED: kc
} = H0;
function D0(e) {
  this.options = rt.assign({
    level: yc,
    method: kc,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: mc
  }, e || {});
  let r = this.options;
  r.raw && r.windowBits > 0 ? r.windowBits = -r.windowBits : r.gzip && r.windowBits > 0 && r.windowBits < 16 && (r.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Ti(), this.strm.avail_out = 0;
  let t = g0.deflateInit2(
    this.strm,
    r.level,
    r.method,
    r.windowBits,
    r.memLevel,
    r.strategy
  );
  if (t !== X0)
    throw new Error(Ye[t]);
  if (r.header && g0.deflateSetHeader(this.strm, r.header), r.dictionary) {
    let a;
    if (typeof r.dictionary == "string" ? a = A0.string2buf(r.dictionary) : Oi.call(r.dictionary) === "[object ArrayBuffer]" ? a = new Uint8Array(r.dictionary) : a = r.dictionary, t = g0.deflateSetDictionary(this.strm, a), t !== X0)
      throw new Error(Ye[t]);
    this._dict_set = !0;
  }
}
D0.prototype.push = function(e, r) {
  const t = this.strm, a = this.options.chunkSize;
  let n, o;
  if (this.ended)
    return !1;
  for (r === ~~r ? o = r : o = r === !0 ? bc : vc, typeof e == "string" ? t.input = A0.string2buf(e) : Oi.call(e) === "[object ArrayBuffer]" ? t.input = new Uint8Array(e) : t.input = e, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    if (t.avail_out === 0 && (t.output = new Uint8Array(a), t.next_out = 0, t.avail_out = a), (o === pc || o === gc) && t.avail_out <= 6) {
      this.onData(t.output.subarray(0, t.next_out)), t.avail_out = 0;
      continue;
    }
    if (n = g0.deflate(t, o), n === wc)
      return t.next_out > 0 && this.onData(t.output.subarray(0, t.next_out)), n = g0.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === X0;
    if (t.avail_out === 0) {
      this.onData(t.output);
      continue;
    }
    if (o > 0 && t.next_out > 0) {
      this.onData(t.output.subarray(0, t.next_out)), t.avail_out = 0;
      continue;
    }
    if (t.avail_in === 0)
      break;
  }
  return !0;
};
D0.prototype.onData = function(e) {
  this.chunks.push(e);
};
D0.prototype.onEnd = function(e) {
  e === X0 && (this.result = rt.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function Fr(e, r) {
  const t = new D0(r);
  if (t.push(e, !0), t.err)
    throw t.msg || Ye[t.err];
  return t.result;
}
function Sc(e, r) {
  return r = r || {}, r.raw = !0, Fr(e, r);
}
function Ec(e, r) {
  return r = r || {}, r.gzip = !0, Fr(e, r);
}
var Cc = D0, Ac = Fr, Bc = Sc, Rc = Ec, zc = H0, Hc = {
  Deflate: Cc,
  deflate: Ac,
  deflateRaw: Bc,
  gzip: Rc,
  constants: zc
};
const P0 = 16209, Uc = 16191;
var Dc = function(r, t) {
  let a, n, o, u, f, h, i, s, b, l, c, d, _, g, y, v, p, x, S, E, k, C, A, w;
  const m = r.state;
  a = r.next_in, A = r.input, n = a + (r.avail_in - 5), o = r.next_out, w = r.output, u = o - (t - r.avail_out), f = o + (r.avail_out - 257), h = m.dmax, i = m.wsize, s = m.whave, b = m.wnext, l = m.window, c = m.hold, d = m.bits, _ = m.lencode, g = m.distcode, y = (1 << m.lenbits) - 1, v = (1 << m.distbits) - 1;
  e:
    do {
      d < 15 && (c += A[a++] << d, d += 8, c += A[a++] << d, d += 8), p = _[c & y];
      t:
        for (; ; ) {
          if (x = p >>> 24, c >>>= x, d -= x, x = p >>> 16 & 255, x === 0)
            w[o++] = p & 65535;
          else if (x & 16) {
            S = p & 65535, x &= 15, x && (d < x && (c += A[a++] << d, d += 8), S += c & (1 << x) - 1, c >>>= x, d -= x), d < 15 && (c += A[a++] << d, d += 8, c += A[a++] << d, d += 8), p = g[c & v];
            r:
              for (; ; ) {
                if (x = p >>> 24, c >>>= x, d -= x, x = p >>> 16 & 255, x & 16) {
                  if (E = p & 65535, x &= 15, d < x && (c += A[a++] << d, d += 8, d < x && (c += A[a++] << d, d += 8)), E += c & (1 << x) - 1, E > h) {
                    r.msg = "invalid distance too far back", m.mode = P0;
                    break e;
                  }
                  if (c >>>= x, d -= x, x = o - u, E > x) {
                    if (x = E - x, x > s && m.sane) {
                      r.msg = "invalid distance too far back", m.mode = P0;
                      break e;
                    }
                    if (k = 0, C = l, b === 0) {
                      if (k += i - x, x < S) {
                        S -= x;
                        do
                          w[o++] = l[k++];
                        while (--x);
                        k = o - E, C = w;
                      }
                    } else if (b < x) {
                      if (k += i + b - x, x -= b, x < S) {
                        S -= x;
                        do
                          w[o++] = l[k++];
                        while (--x);
                        if (k = 0, b < S) {
                          x = b, S -= x;
                          do
                            w[o++] = l[k++];
                          while (--x);
                          k = o - E, C = w;
                        }
                      }
                    } else if (k += b - x, x < S) {
                      S -= x;
                      do
                        w[o++] = l[k++];
                      while (--x);
                      k = o - E, C = w;
                    }
                    for (; S > 2; )
                      w[o++] = C[k++], w[o++] = C[k++], w[o++] = C[k++], S -= 3;
                    S && (w[o++] = C[k++], S > 1 && (w[o++] = C[k++]));
                  } else {
                    k = o - E;
                    do
                      w[o++] = w[k++], w[o++] = w[k++], w[o++] = w[k++], S -= 3;
                    while (S > 2);
                    S && (w[o++] = w[k++], S > 1 && (w[o++] = w[k++]));
                  }
                } else if (x & 64) {
                  r.msg = "invalid distance code", m.mode = P0;
                  break e;
                } else {
                  p = g[(p & 65535) + (c & (1 << x) - 1)];
                  continue r;
                }
                break;
              }
          } else if (x & 64)
            if (x & 32) {
              m.mode = Uc;
              break e;
            } else {
              r.msg = "invalid literal/length code", m.mode = P0;
              break e;
            }
          else {
            p = _[(p & 65535) + (c & (1 << x) - 1)];
            continue t;
          }
          break;
        }
    } while (a < n && o < f);
  S = d >> 3, a -= S, d -= S << 3, c &= (1 << d) - 1, r.next_in = a, r.next_out = o, r.avail_in = a < n ? 5 + (n - a) : 5 - (a - n), r.avail_out = o < f ? 257 + (f - o) : 257 - (o - f), m.hold = c, m.bits = d;
};
const Xe = 15, xn = 852, hn = 592, _n = 0, sr = 1, vn = 2, Tc = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), Oc = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), Ic = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), Fc = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), Lc = (e, r, t, a, n, o, u, f) => {
  const h = f.bits;
  let i = 0, s = 0, b = 0, l = 0, c = 0, d = 0, _ = 0, g = 0, y = 0, v = 0, p, x, S, E, k, C = null, A;
  const w = new Uint16Array(Xe + 1), m = new Uint16Array(Xe + 1);
  let B = null, z, T, O;
  for (i = 0; i <= Xe; i++)
    w[i] = 0;
  for (s = 0; s < a; s++)
    w[r[t + s]]++;
  for (c = h, l = Xe; l >= 1 && w[l] === 0; l--)
    ;
  if (c > l && (c = l), l === 0)
    return n[o++] = 1 << 24 | 64 << 16 | 0, n[o++] = 1 << 24 | 64 << 16 | 0, f.bits = 1, 0;
  for (b = 1; b < l && w[b] === 0; b++)
    ;
  for (c < b && (c = b), g = 1, i = 1; i <= Xe; i++)
    if (g <<= 1, g -= w[i], g < 0)
      return -1;
  if (g > 0 && (e === _n || l !== 1))
    return -1;
  for (m[1] = 0, i = 1; i < Xe; i++)
    m[i + 1] = m[i] + w[i];
  for (s = 0; s < a; s++)
    r[t + s] !== 0 && (u[m[r[t + s]]++] = s);
  if (e === _n ? (C = B = u, A = 20) : e === sr ? (C = Tc, B = Oc, A = 257) : (C = Ic, B = Fc, A = 0), v = 0, s = 0, i = b, k = o, d = c, _ = 0, S = -1, y = 1 << c, E = y - 1, e === sr && y > xn || e === vn && y > hn)
    return 1;
  for (; ; ) {
    z = i - _, u[s] + 1 < A ? (T = 0, O = u[s]) : u[s] >= A ? (T = B[u[s] - A], O = C[u[s] - A]) : (T = 32 + 64, O = 0), p = 1 << i - _, x = 1 << d, b = x;
    do
      x -= p, n[k + (v >> _) + x] = z << 24 | T << 16 | O | 0;
    while (x !== 0);
    for (p = 1 << i - 1; v & p; )
      p >>= 1;
    if (p !== 0 ? (v &= p - 1, v += p) : v = 0, s++, --w[i] === 0) {
      if (i === l)
        break;
      i = r[t + u[s]];
    }
    if (i > c && (v & E) !== S) {
      for (_ === 0 && (_ = c), k += b, d = i - _, g = 1 << d; d + _ < l && (g -= w[d + _], !(g <= 0)); )
        d++, g <<= 1;
      if (y += 1 << d, e === sr && y > xn || e === vn && y > hn)
        return 1;
      S = v & E, n[S] = c << 24 | d << 16 | k - o | 0;
    }
  }
  return v !== 0 && (n[k + v] = i - _ << 24 | 64 << 16 | 0), f.bits = c, 0;
};
var b0 = Lc;
const Pc = 0, Ii = 1, Fi = 2, {
  Z_FINISH: pn,
  Z_BLOCK: Nc,
  Z_TREES: N0,
  Z_OK: Fe,
  Z_STREAM_END: qc,
  Z_NEED_DICT: $c,
  Z_STREAM_ERROR: ue,
  Z_DATA_ERROR: Li,
  Z_MEM_ERROR: Pi,
  Z_BUF_ERROR: Zc,
  Z_DEFLATED: gn
} = H0, at = 16180, bn = 16181, wn = 16182, yn = 16183, mn = 16184, kn = 16185, Sn = 16186, En = 16187, Cn = 16188, An = 16189, G0 = 16190, be = 16191, fr = 16192, Bn = 16193, cr = 16194, Rn = 16195, zn = 16196, Hn = 16197, Un = 16198, q0 = 16199, $0 = 16200, Dn = 16201, Tn = 16202, On = 16203, In = 16204, Fn = 16205, lr = 16206, Ln = 16207, Pn = 16208, X = 16209, Ni = 16210, qi = 16211, Mc = 852, Wc = 592, Kc = 15, jc = Kc, Nn = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function Xc() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const qe = (e) => {
  if (!e)
    return 1;
  const r = e.state;
  return !r || r.strm !== e || r.mode < at || r.mode > qi ? 1 : 0;
}, $i = (e) => {
  if (qe(e))
    return ue;
  const r = e.state;
  return e.total_in = e.total_out = r.total = 0, e.msg = "", r.wrap && (e.adler = r.wrap & 1), r.mode = at, r.last = 0, r.havedict = 0, r.flags = -1, r.dmax = 32768, r.head = null, r.hold = 0, r.bits = 0, r.lencode = r.lendyn = new Int32Array(Mc), r.distcode = r.distdyn = new Int32Array(Wc), r.sane = 1, r.back = -1, Fe;
}, Zi = (e) => {
  if (qe(e))
    return ue;
  const r = e.state;
  return r.wsize = 0, r.whave = 0, r.wnext = 0, $i(e);
}, Mi = (e, r) => {
  let t;
  if (qe(e))
    return ue;
  const a = e.state;
  return r < 0 ? (t = 0, r = -r) : (t = (r >> 4) + 5, r < 48 && (r &= 15)), r && (r < 8 || r > 15) ? ue : (a.window !== null && a.wbits !== r && (a.window = null), a.wrap = t, a.wbits = r, Zi(e));
}, Wi = (e, r) => {
  if (!e)
    return ue;
  const t = new Xc();
  e.state = t, t.strm = e, t.window = null, t.mode = at;
  const a = Mi(e, r);
  return a !== Fe && (e.state = null), a;
}, Gc = (e) => Wi(e, jc);
let qn = !0, ur, dr;
const Yc = (e) => {
  if (qn) {
    ur = new Int32Array(512), dr = new Int32Array(32);
    let r = 0;
    for (; r < 144; )
      e.lens[r++] = 8;
    for (; r < 256; )
      e.lens[r++] = 9;
    for (; r < 280; )
      e.lens[r++] = 7;
    for (; r < 288; )
      e.lens[r++] = 8;
    for (b0(Ii, e.lens, 0, 288, ur, 0, e.work, { bits: 9 }), r = 0; r < 32; )
      e.lens[r++] = 5;
    b0(Fi, e.lens, 0, 32, dr, 0, e.work, { bits: 5 }), qn = !1;
  }
  e.lencode = ur, e.lenbits = 9, e.distcode = dr, e.distbits = 5;
}, Ki = (e, r, t, a) => {
  let n;
  const o = e.state;
  return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), a >= o.wsize ? (o.window.set(r.subarray(t - o.wsize, t), 0), o.wnext = 0, o.whave = o.wsize) : (n = o.wsize - o.wnext, n > a && (n = a), o.window.set(r.subarray(t - a, t - a + n), o.wnext), a -= n, a ? (o.window.set(r.subarray(t - a, t), 0), o.wnext = a, o.whave = o.wsize) : (o.wnext += n, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += n))), 0;
}, Qc = (e, r) => {
  let t, a, n, o, u, f, h, i, s, b, l, c, d, _, g = 0, y, v, p, x, S, E, k, C;
  const A = new Uint8Array(4);
  let w, m;
  const B = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (qe(e) || !e.output || !e.input && e.avail_in !== 0)
    return ue;
  t = e.state, t.mode === be && (t.mode = fr), u = e.next_out, n = e.output, h = e.avail_out, o = e.next_in, a = e.input, f = e.avail_in, i = t.hold, s = t.bits, b = f, l = h, C = Fe;
  e:
    for (; ; )
      switch (t.mode) {
        case at:
          if (t.wrap === 0) {
            t.mode = fr;
            break;
          }
          for (; s < 16; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if (t.wrap & 2 && i === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, A[0] = i & 255, A[1] = i >>> 8 & 255, t.check = G(t.check, A, 2, 0), i = 0, s = 0, t.mode = bn;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((i & 255) << 8) + (i >> 8)) % 31) {
            e.msg = "incorrect header check", t.mode = X;
            break;
          }
          if ((i & 15) !== gn) {
            e.msg = "unknown compression method", t.mode = X;
            break;
          }
          if (i >>>= 4, s -= 4, k = (i & 15) + 8, t.wbits === 0 && (t.wbits = k), k > 15 || k > t.wbits) {
            e.msg = "invalid window size", t.mode = X;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, e.adler = t.check = 1, t.mode = i & 512 ? An : be, i = 0, s = 0;
          break;
        case bn:
          for (; s < 16; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if (t.flags = i, (t.flags & 255) !== gn) {
            e.msg = "unknown compression method", t.mode = X;
            break;
          }
          if (t.flags & 57344) {
            e.msg = "unknown header flags set", t.mode = X;
            break;
          }
          t.head && (t.head.text = i >> 8 & 1), t.flags & 512 && t.wrap & 4 && (A[0] = i & 255, A[1] = i >>> 8 & 255, t.check = G(t.check, A, 2, 0)), i = 0, s = 0, t.mode = wn;
        case wn:
          for (; s < 32; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          t.head && (t.head.time = i), t.flags & 512 && t.wrap & 4 && (A[0] = i & 255, A[1] = i >>> 8 & 255, A[2] = i >>> 16 & 255, A[3] = i >>> 24 & 255, t.check = G(t.check, A, 4, 0)), i = 0, s = 0, t.mode = yn;
        case yn:
          for (; s < 16; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          t.head && (t.head.xflags = i & 255, t.head.os = i >> 8), t.flags & 512 && t.wrap & 4 && (A[0] = i & 255, A[1] = i >>> 8 & 255, t.check = G(t.check, A, 2, 0)), i = 0, s = 0, t.mode = mn;
        case mn:
          if (t.flags & 1024) {
            for (; s < 16; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            t.length = i, t.head && (t.head.extra_len = i), t.flags & 512 && t.wrap & 4 && (A[0] = i & 255, A[1] = i >>> 8 & 255, t.check = G(t.check, A, 2, 0)), i = 0, s = 0;
          } else
            t.head && (t.head.extra = null);
          t.mode = kn;
        case kn:
          if (t.flags & 1024 && (c = t.length, c > f && (c = f), c && (t.head && (k = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            a.subarray(
              o,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              o + c
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            k
          )), t.flags & 512 && t.wrap & 4 && (t.check = G(t.check, a, c, o)), f -= c, o += c, t.length -= c), t.length))
            break e;
          t.length = 0, t.mode = Sn;
        case Sn:
          if (t.flags & 2048) {
            if (f === 0)
              break e;
            c = 0;
            do
              k = a[o + c++], t.head && k && t.length < 65536 && (t.head.name += String.fromCharCode(k));
            while (k && c < f);
            if (t.flags & 512 && t.wrap & 4 && (t.check = G(t.check, a, c, o)), f -= c, o += c, k)
              break e;
          } else
            t.head && (t.head.name = null);
          t.length = 0, t.mode = En;
        case En:
          if (t.flags & 4096) {
            if (f === 0)
              break e;
            c = 0;
            do
              k = a[o + c++], t.head && k && t.length < 65536 && (t.head.comment += String.fromCharCode(k));
            while (k && c < f);
            if (t.flags & 512 && t.wrap & 4 && (t.check = G(t.check, a, c, o)), f -= c, o += c, k)
              break e;
          } else
            t.head && (t.head.comment = null);
          t.mode = Cn;
        case Cn:
          if (t.flags & 512) {
            for (; s < 16; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            if (t.wrap & 4 && i !== (t.check & 65535)) {
              e.msg = "header crc mismatch", t.mode = X;
              break;
            }
            i = 0, s = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = be;
          break;
        case An:
          for (; s < 32; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          e.adler = t.check = Nn(i), i = 0, s = 0, t.mode = G0;
        case G0:
          if (t.havedict === 0)
            return e.next_out = u, e.avail_out = h, e.next_in = o, e.avail_in = f, t.hold = i, t.bits = s, $c;
          e.adler = t.check = 1, t.mode = be;
        case be:
          if (r === Nc || r === N0)
            break e;
        case fr:
          if (t.last) {
            i >>>= s & 7, s -= s & 7, t.mode = lr;
            break;
          }
          for (; s < 3; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          switch (t.last = i & 1, i >>>= 1, s -= 1, i & 3) {
            case 0:
              t.mode = Bn;
              break;
            case 1:
              if (Yc(t), t.mode = q0, r === N0) {
                i >>>= 2, s -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = zn;
              break;
            case 3:
              e.msg = "invalid block type", t.mode = X;
          }
          i >>>= 2, s -= 2;
          break;
        case Bn:
          for (i >>>= s & 7, s -= s & 7; s < 32; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if ((i & 65535) !== (i >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", t.mode = X;
            break;
          }
          if (t.length = i & 65535, i = 0, s = 0, t.mode = cr, r === N0)
            break e;
        case cr:
          t.mode = Rn;
        case Rn:
          if (c = t.length, c) {
            if (c > f && (c = f), c > h && (c = h), c === 0)
              break e;
            n.set(a.subarray(o, o + c), u), f -= c, o += c, h -= c, u += c, t.length -= c;
            break;
          }
          t.mode = be;
          break;
        case zn:
          for (; s < 14; ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if (t.nlen = (i & 31) + 257, i >>>= 5, s -= 5, t.ndist = (i & 31) + 1, i >>>= 5, s -= 5, t.ncode = (i & 15) + 4, i >>>= 4, s -= 4, t.nlen > 286 || t.ndist > 30) {
            e.msg = "too many length or distance symbols", t.mode = X;
            break;
          }
          t.have = 0, t.mode = Hn;
        case Hn:
          for (; t.have < t.ncode; ) {
            for (; s < 3; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            t.lens[B[t.have++]] = i & 7, i >>>= 3, s -= 3;
          }
          for (; t.have < 19; )
            t.lens[B[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, w = { bits: t.lenbits }, C = b0(Pc, t.lens, 0, 19, t.lencode, 0, t.work, w), t.lenbits = w.bits, C) {
            e.msg = "invalid code lengths set", t.mode = X;
            break;
          }
          t.have = 0, t.mode = Un;
        case Un:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; g = t.lencode[i & (1 << t.lenbits) - 1], y = g >>> 24, v = g >>> 16 & 255, p = g & 65535, !(y <= s); ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            if (p < 16)
              i >>>= y, s -= y, t.lens[t.have++] = p;
            else {
              if (p === 16) {
                for (m = y + 2; s < m; ) {
                  if (f === 0)
                    break e;
                  f--, i += a[o++] << s, s += 8;
                }
                if (i >>>= y, s -= y, t.have === 0) {
                  e.msg = "invalid bit length repeat", t.mode = X;
                  break;
                }
                k = t.lens[t.have - 1], c = 3 + (i & 3), i >>>= 2, s -= 2;
              } else if (p === 17) {
                for (m = y + 3; s < m; ) {
                  if (f === 0)
                    break e;
                  f--, i += a[o++] << s, s += 8;
                }
                i >>>= y, s -= y, k = 0, c = 3 + (i & 7), i >>>= 3, s -= 3;
              } else {
                for (m = y + 7; s < m; ) {
                  if (f === 0)
                    break e;
                  f--, i += a[o++] << s, s += 8;
                }
                i >>>= y, s -= y, k = 0, c = 11 + (i & 127), i >>>= 7, s -= 7;
              }
              if (t.have + c > t.nlen + t.ndist) {
                e.msg = "invalid bit length repeat", t.mode = X;
                break;
              }
              for (; c--; )
                t.lens[t.have++] = k;
            }
          }
          if (t.mode === X)
            break;
          if (t.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", t.mode = X;
            break;
          }
          if (t.lenbits = 9, w = { bits: t.lenbits }, C = b0(Ii, t.lens, 0, t.nlen, t.lencode, 0, t.work, w), t.lenbits = w.bits, C) {
            e.msg = "invalid literal/lengths set", t.mode = X;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, w = { bits: t.distbits }, C = b0(Fi, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, w), t.distbits = w.bits, C) {
            e.msg = "invalid distances set", t.mode = X;
            break;
          }
          if (t.mode = q0, r === N0)
            break e;
        case q0:
          t.mode = $0;
        case $0:
          if (f >= 6 && h >= 258) {
            e.next_out = u, e.avail_out = h, e.next_in = o, e.avail_in = f, t.hold = i, t.bits = s, Dc(e, l), u = e.next_out, n = e.output, h = e.avail_out, o = e.next_in, a = e.input, f = e.avail_in, i = t.hold, s = t.bits, t.mode === be && (t.back = -1);
            break;
          }
          for (t.back = 0; g = t.lencode[i & (1 << t.lenbits) - 1], y = g >>> 24, v = g >>> 16 & 255, p = g & 65535, !(y <= s); ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if (v && !(v & 240)) {
            for (x = y, S = v, E = p; g = t.lencode[E + ((i & (1 << x + S) - 1) >> x)], y = g >>> 24, v = g >>> 16 & 255, p = g & 65535, !(x + y <= s); ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            i >>>= x, s -= x, t.back += x;
          }
          if (i >>>= y, s -= y, t.back += y, t.length = p, v === 0) {
            t.mode = Fn;
            break;
          }
          if (v & 32) {
            t.back = -1, t.mode = be;
            break;
          }
          if (v & 64) {
            e.msg = "invalid literal/length code", t.mode = X;
            break;
          }
          t.extra = v & 15, t.mode = Dn;
        case Dn:
          if (t.extra) {
            for (m = t.extra; s < m; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            t.length += i & (1 << t.extra) - 1, i >>>= t.extra, s -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = Tn;
        case Tn:
          for (; g = t.distcode[i & (1 << t.distbits) - 1], y = g >>> 24, v = g >>> 16 & 255, p = g & 65535, !(y <= s); ) {
            if (f === 0)
              break e;
            f--, i += a[o++] << s, s += 8;
          }
          if (!(v & 240)) {
            for (x = y, S = v, E = p; g = t.distcode[E + ((i & (1 << x + S) - 1) >> x)], y = g >>> 24, v = g >>> 16 & 255, p = g & 65535, !(x + y <= s); ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            i >>>= x, s -= x, t.back += x;
          }
          if (i >>>= y, s -= y, t.back += y, v & 64) {
            e.msg = "invalid distance code", t.mode = X;
            break;
          }
          t.offset = p, t.extra = v & 15, t.mode = On;
        case On:
          if (t.extra) {
            for (m = t.extra; s < m; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            t.offset += i & (1 << t.extra) - 1, i >>>= t.extra, s -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            e.msg = "invalid distance too far back", t.mode = X;
            break;
          }
          t.mode = In;
        case In:
          if (h === 0)
            break e;
          if (c = l - h, t.offset > c) {
            if (c = t.offset - c, c > t.whave && t.sane) {
              e.msg = "invalid distance too far back", t.mode = X;
              break;
            }
            c > t.wnext ? (c -= t.wnext, d = t.wsize - c) : d = t.wnext - c, c > t.length && (c = t.length), _ = t.window;
          } else
            _ = n, d = u - t.offset, c = t.length;
          c > h && (c = h), h -= c, t.length -= c;
          do
            n[u++] = _[d++];
          while (--c);
          t.length === 0 && (t.mode = $0);
          break;
        case Fn:
          if (h === 0)
            break e;
          n[u++] = t.length, h--, t.mode = $0;
          break;
        case lr:
          if (t.wrap) {
            for (; s < 32; ) {
              if (f === 0)
                break e;
              f--, i |= a[o++] << s, s += 8;
            }
            if (l -= h, e.total_out += l, t.total += l, t.wrap & 4 && l && (e.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? G(t.check, n, l, u - l) : E0(t.check, n, l, u - l)), l = h, t.wrap & 4 && (t.flags ? i : Nn(i)) !== t.check) {
              e.msg = "incorrect data check", t.mode = X;
              break;
            }
            i = 0, s = 0;
          }
          t.mode = Ln;
        case Ln:
          if (t.wrap && t.flags) {
            for (; s < 32; ) {
              if (f === 0)
                break e;
              f--, i += a[o++] << s, s += 8;
            }
            if (t.wrap & 4 && i !== (t.total & 4294967295)) {
              e.msg = "incorrect length check", t.mode = X;
              break;
            }
            i = 0, s = 0;
          }
          t.mode = Pn;
        case Pn:
          C = qc;
          break e;
        case X:
          C = Li;
          break e;
        case Ni:
          return Pi;
        case qi:
        default:
          return ue;
      }
  return e.next_out = u, e.avail_out = h, e.next_in = o, e.avail_in = f, t.hold = i, t.bits = s, (t.wsize || l !== e.avail_out && t.mode < X && (t.mode < lr || r !== pn)) && Ki(e, e.output, e.next_out, l - e.avail_out), b -= e.avail_in, l -= e.avail_out, e.total_in += b, e.total_out += l, t.total += l, t.wrap & 4 && l && (e.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? G(t.check, n, l, e.next_out - l) : E0(t.check, n, l, e.next_out - l)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === be ? 128 : 0) + (t.mode === q0 || t.mode === cr ? 256 : 0), (b === 0 && l === 0 || r === pn) && C === Fe && (C = Zc), C;
}, Vc = (e) => {
  if (qe(e))
    return ue;
  let r = e.state;
  return r.window && (r.window = null), e.state = null, Fe;
}, Jc = (e, r) => {
  if (qe(e))
    return ue;
  const t = e.state;
  return t.wrap & 2 ? (t.head = r, r.done = !1, Fe) : ue;
}, el = (e, r) => {
  const t = r.length;
  let a, n, o;
  return qe(e) || (a = e.state, a.wrap !== 0 && a.mode !== G0) ? ue : a.mode === G0 && (n = 1, n = E0(n, r, t, 0), n !== a.check) ? Li : (o = Ki(e, r, t, t), o ? (a.mode = Ni, Pi) : (a.havedict = 1, Fe));
};
var tl = Zi, rl = Mi, al = $i, nl = Gc, il = Wi, ol = Qc, sl = Vc, fl = Jc, cl = el, ll = "pako inflate (from Nodeca project)", ye = {
  inflateReset: tl,
  inflateReset2: rl,
  inflateResetKeep: al,
  inflateInit: nl,
  inflateInit2: il,
  inflate: ol,
  inflateEnd: sl,
  inflateGetHeader: fl,
  inflateSetDictionary: cl,
  inflateInfo: ll
};
function ul() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var dl = ul;
const ji = Object.prototype.toString, {
  Z_NO_FLUSH: xl,
  Z_FINISH: hl,
  Z_OK: B0,
  Z_STREAM_END: xr,
  Z_NEED_DICT: hr,
  Z_STREAM_ERROR: _l,
  Z_DATA_ERROR: $n,
  Z_MEM_ERROR: vl
} = H0;
function Lr(e) {
  this.options = rt.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const r = this.options;
  r.raw && r.windowBits >= 0 && r.windowBits < 16 && (r.windowBits = -r.windowBits, r.windowBits === 0 && (r.windowBits = -15)), r.windowBits >= 0 && r.windowBits < 16 && !(e && e.windowBits) && (r.windowBits += 32), r.windowBits > 15 && r.windowBits < 48 && (r.windowBits & 15 || (r.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Ti(), this.strm.avail_out = 0;
  let t = ye.inflateInit2(
    this.strm,
    r.windowBits
  );
  if (t !== B0)
    throw new Error(Ye[t]);
  if (this.header = new dl(), ye.inflateGetHeader(this.strm, this.header), r.dictionary && (typeof r.dictionary == "string" ? r.dictionary = A0.string2buf(r.dictionary) : ji.call(r.dictionary) === "[object ArrayBuffer]" && (r.dictionary = new Uint8Array(r.dictionary)), r.raw && (t = ye.inflateSetDictionary(this.strm, r.dictionary), t !== B0)))
    throw new Error(Ye[t]);
}
Lr.prototype.push = function(e, r) {
  const t = this.strm, a = this.options.chunkSize, n = this.options.dictionary;
  let o, u, f;
  if (this.ended)
    return !1;
  for (r === ~~r ? u = r : u = r === !0 ? hl : xl, ji.call(e) === "[object ArrayBuffer]" ? t.input = new Uint8Array(e) : t.input = e, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(a), t.next_out = 0, t.avail_out = a), o = ye.inflate(t, u), o === hr && n && (o = ye.inflateSetDictionary(t, n), o === B0 ? o = ye.inflate(t, u) : o === $n && (o = hr)); t.avail_in > 0 && o === xr && t.state.wrap > 0 && e[t.next_in] !== 0; )
      ye.inflateReset(t), o = ye.inflate(t, u);
    switch (o) {
      case _l:
      case $n:
      case hr:
      case vl:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (f = t.avail_out, t.next_out && (t.avail_out === 0 || o === xr))
      if (this.options.to === "string") {
        let h = A0.utf8border(t.output, t.next_out), i = t.next_out - h, s = A0.buf2string(t.output, h);
        t.next_out = i, t.avail_out = a - i, i && t.output.set(t.output.subarray(h, h + i), 0), this.onData(s);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out));
    if (!(o === B0 && f === 0)) {
      if (o === xr)
        return o = ye.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (t.avail_in === 0)
        break;
    }
  }
  return !0;
};
Lr.prototype.onData = function(e) {
  this.chunks.push(e);
};
Lr.prototype.onEnd = function(e) {
  e === B0 && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = rt.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
const { Deflate: yl, deflate: ml, deflateRaw: kl, gzip: pl } = Hc;
var gl = pl;
class bl {
  get baseUrl() {
    var r;
    return (r = ci()) == null ? void 0 : r.baseUrl;
  }
  FsApiServiceImpl() {
  }
  getHeaders() {
    return {
      headers: {
        "content-type": "application/json;charset=UTF-8"
      }
    };
  }
  /**
   * 验证文件是否已存在，存在则秒传
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async checkSha1(r) {
    const t = `${this.baseUrl}/file/getFileBySHA1?fileSHA1=${r}`, a = await J.get(t, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  /**
   * 验证文件是否已存在，存在则秒传
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async listCheckSha1(r) {
    const t = `${this.baseUrl}/file/listFileBySha1s`, a = await J.post(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  /**
   * 从文件服务获取签名，方便后续上传
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async getSignature(r) {
    const t = `${this.baseUrl}/v2/getSignature?sha1=${r.sha1}&suffix=${r.suffix}`, a = await J.get(t, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  /**
   * 批量从文件服务获取签名，方便后续上传
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async listSignature(r) {
    const t = `${this.baseUrl}/v2/listSignature`, a = await J.post(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  /**
   * 缓存至文件服务
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async insertFile(r) {
    const t = `${this.baseUrl}/file/insertFile`, a = await J.post(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  /**
   * 缓存至文件服务
   * @param fileSHA1 // 文件的sha1值
   * @returns
   */
  async listInsertFile(r) {
    const t = `${this.baseUrl}/fileServerDb/insertFileBatchAsync`, a = await J.put(t, r, this.getHeaders());
    if (a.data.code === 200)
      return a.data.data;
    throw new Error(a.data.message);
  }
  // ------------------------------------------------------------------
  /**
   * 上传内容至OSS
   * @param uploadUrl OSS上传路径
   * @param file 文件内容
   * @param opts 定制化headers
   * @returns
   */
  async uploadToOSS(r, t, a, n = !1) {
    const o = n ? t : gl(t), u = { "content-encoding": "gzip" };
    return Object.assign(u, a), await J.put(r, o, {
      headers: u
    }).catch(() => {
      throw new Error("上传失败");
    }), !0;
  }
}
const Se = new bl();
function Zn(e, r = 50) {
  r || (r = 50);
  const t = e.length, a = t % r === 0 ? t / r : t / r + 1;
  let n = [];
  for (let o = 0; o < a; o++) {
    let u = [];
    o == t - 1 ? u = e.slice(r * o, t) : u = e.slice(r * o, r * (o + 1)), u.length > 0 && n.push(u);
  }
  return n;
}
class Sl {
  constructor() {
    this._init = !1;
  }
  download() {
    throw new Error("Method not implemented.");
  }
  /**
   * 注册-文件上传完成回调
   * 触发时机:
   * 1. 用户调用upload上传完成后
   * @param callback
   */
  registerOnUploadCallback(r) {
    this._uploadCallback = r;
  }
  /**
   * 注册-文件下载完成的回调
   * 触发时机:
   * 1. 用户token过期
   * 2. 用户切换
   * 3. 代码主动调用logout函数
   * @param callback
   */
  registerOnDownloadCallback(r) {
    this._downloadCallback = r;
  }
  /**
   * 初始化配置
   * @param config
   */
  init(r) {
    if (!this._init)
      bs(r);
    else
      throw new Error("重复初始化");
  }
  /**
   * 上传单个文件
   * @returns
   */
  async uploadFile(r, t = { compressed: !1 }) {
    const { compressed: a } = t, { name: n, size: o, sha1: u, suffix: f, uint8Array: h } = await this.getSha1(r);
    if (o > 1024e6)
      throw new Error("文件超过1G");
    const i = await Se.checkSha1(u);
    if (i) {
      const { sha1: _, path: g } = i;
      return {
        fileSize: o,
        fileSHA1: u,
        fileAddress: g,
        fileName: n,
        fileOssPath: g
      };
    }
    const s = {
      sha1: u,
      suffix: f
    }, { uploadUrl: b, fileOssPath: l, mime: c } = await Se.getSignature(s);
    await Se.uploadToOSS(b, h, { "content-type": c }, a).catch((_) => {
      throw _;
    });
    const d = {
      sha1: u,
      path: l
    };
    return await Se.insertFile(d), {
      fileSize: o,
      fileSHA1: u,
      fileAddress: l,
      fileName: n,
      fileOssPath: l
    };
  }
  /**
   * 上传多个文件
   * @returns
   */
  async uploadFiles(r, t, a = { compressed: !1 }) {
    const { compressed: n } = a, { splitCount: o } = ci();
    t || (t = o);
    let u = [];
    for (let c = 0; c < r.length; c++)
      u.push(await this.getSha1(r[c]));
    let f = [];
    for (let c = 0; c < u.length; c++) {
      const { name: d, size: _, sha1: g, suffix: y, uint8Array: v } = u[c];
      f.push({
        fileSize: _,
        fileSHA1: g,
        fileAddress: "",
        fileName: d,
        fileOssPath: "",
        suffix: y,
        uint8Array: v,
        needUpload: !0
      });
    }
    const h = f.map((c) => c.fileSHA1);
    var i = Zn(h, t);
    for (let c = 0; c < i.length; c++) {
      const d = await Se.listCheckSha1(i[c]);
      if (d)
        for (const [_, g] of Object.entries(d)) {
          const y = f.find((v) => v.fileSHA1 === _);
          y && (y.fileOssPath = g, y.needUpload = !1);
        }
    }
    const s = f.filter((c) => !c.fileOssPath).map((c) => ({
      sha1: c.fileSHA1,
      suffix: c.suffix
    })), b = Zn(s, t);
    for (let c = 0; c < b.length; c++) {
      const d = b[c], _ = await Se.listSignature(d);
      if (_) {
        let g = [];
        for (const [y, v] of Object.entries(_)) {
          const p = f.find((x) => x.fileSHA1 === y);
          if (p && p.uint8Array) {
            const { uploadUrl: x, fileOssPath: S, mime: E } = v;
            await Se.uploadToOSS(
              x,
              p.uint8Array,
              { "content-type": E },
              n
            ).catch((C) => {
              throw C;
            }) && (p.fileOssPath = S, g.push({ sha1: p.fileSHA1, path: p.fileOssPath }));
          }
        }
        g.length > 0 && await Se.listInsertFile(g);
      }
    }
    return f.filter((c) => c.fileOssPath).map((c) => ({
      fileSize: c.fileSize,
      fileSHA1: c.fileSHA1,
      fileAddress: c.fileOssPath,
      fileName: c.fileName,
      fileOssPath: c.fileOssPath
    }));
  }
  /**
   * 分片读取文件
   * @param file
   * @param start
   * @param size
   * @returns
   */
  async _readSlice(r, t, a) {
    return new Promise((n, o) => {
      const u = new FileReader(), f = r.slice(t, t + a);
      u.onload = () => n(new Uint8Array(u.result)), u.onerror = o, u.readAsArrayBuffer(f);
    });
  }
  /**
   * 分片读取文件
   * @param file
   * @param start
   * @param size
   * @returns
   */
  async getSha1(r) {
    let t = tn.algo.SHA1.create();
    const a = 10485760;
    let n = 0;
    const o = new Uint8Array(r.size);
    for (; n < r.size; ) {
      const i = await this._readSlice(r, n, a), s = tn.lib.WordArray.create(i);
      t = t.update(s), o.set(i, n), n += a;
    }
    if (t.finalize(), !o)
      throw new Error("文件没有正确加载");
    const u = t._hash.toString(), f = r.name.split("."), h = f.pop();
    if (f.length < 1 || !h)
      throw new Error("上传文件名格式不正确");
    return {
      name: r.name,
      sha1: u,
      suffix: "." + h,
      size: r.size,
      uint8Array: o
    };
  }
}
export {
  v0 as CookieStorage,
  gs as FILE_SEVER_MODE,
  Sl as FileManager,
  Se as FileService,
  bl as FileServiceImpl,
  fi as JeecgAuthService,
  ps as JeecgAuthServiceImpl,
  wl as UserManager
};
//# sourceMappingURL=index.es.js.map
